// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1.5L6 6.5L11 1.5%27 stroke=%27%23495057%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23374151%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   WIZARD LAYOUT STYLES
   ============================================ */

.wizard-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
  font-family: var(--font-sans, 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: "kern" 1;
  font-kerning: normal;
  color: var(--text-primary);
}

.wizard-layout *,
.wizard-layout *::before,
.wizard-layout *::after {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

.wizard-layout svg {
  shape-rendering: geometricPrecision;
}

.wizard-layout.public {
  background: var(--bg-primary);
}

.wizard-layout.private {
  background: var(--bg-primary);
}

/* Header */
.wizard-header {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 0.85rem 2rem;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: none;
}

.wizard-header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wizard-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.wizard-logo img {
  width: 36px;
  height: 36px;
  display: block;
}

.wizard-logo-text {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--primary-color);
  letter-spacing: -0.5px;
}

.wizard-header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Buttons */
.wizard-exit-btn,
.wizard-save-exit-btn,
.wizard-back-btn {
  padding: 0.5rem 1.25rem;
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.wizard-exit-btn,
.wizard-save-exit-btn {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.wizard-exit-btn:hover,
.wizard-save-exit-btn:hover {
  background: var(--bg-gray-50);
  border-color: var(--text-secondary);
}

.wizard-back-btn {
  background: transparent;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

.wizard-back-btn:hover {
  background: var(--primary-color);
  color: var(--white);
}

/* Main Content */
.wizard-main {
  flex: 1 1;
  padding: 1rem;
  overflow-y: auto;
  max-height: calc(100vh - 80px); /* Account for header */
}

/* Footer */
.wizard-footer {
  background: transparent;
  border-top: 1px solid color-mix(in srgb, var(--border, #334155) 80%, transparent);
  padding: 0.85rem 1.5rem;
  text-align: center;
  color: var(--text-muted, var(--text-secondary, #94a3b8));
  font-size: 0.75rem;
  letter-spacing: 0.01em;
}

.wizard-footer p {
  margin: 0;
  opacity: 0.85;
}

.wizard-layout.public .wizard-footer,
.wizard-layout.private .wizard-footer {
  background: color-mix(in srgb, var(--bg-primary, #07111f) 92%, #000 8%);
}

/* ============================================
   WIZARD CONTAINER & CARD
   ============================================ */

/* ============================================
   WIZARD HERO TITLE (Step 1)
   ============================================ */

.wizard-hero-title {
  text-align: center;
  margin-bottom: 2rem;
  padding: 1.5rem 1rem 0.5rem;
}

.wizard-eyebrow {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--primary);
  margin: 0 0 8px;
}

.wizard-hero-heading {
  font-size: 28px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  line-height: 1.25;
  letter-spacing: -0.02em;
  font-family: var(--font-sans, Inter, sans-serif);
}

.wizard-hero-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 400;
  max-width: 560px;
  margin: 0 auto;
  line-height: 1.5;
}

.wizard-progress-steps {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 20px;
}

.wizard-progress-step {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-muted);
  font-size: 12px;
  font-weight: 500;
}

.wizard-progress-step em {
  font-style: normal;
  font-weight: 600;
  color: var(--text-secondary);
}

.wizard-progress-step.is-active {
  background: var(--primary-muted);
  border-color: transparent;
  color: var(--primary);
}

.wizard-progress-step.is-active em {
  color: var(--primary);
}

@media (max-width: 768px) {
  .wizard-hero-heading {
    font-size: 24px;
  }

  .wizard-hero-subtitle {
    font-size: 13px;
  }

  .wizard-hero-title {
    margin-bottom: 1.25rem;
    padding: 1rem 0.5rem;
  }
}

.wizard-container {
  max-width: 880px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1.5rem 2rem;
}

.wizard-card {
  background: var(--surface);
  border-radius: 12px;
  box-shadow: var(--shadow-xs);
  padding: 1.75rem;
  margin-bottom: 1.5rem;
  border: 1px solid var(--border);
}

.wizard-card-header {
  margin-bottom: 1.25rem;
  text-align: left;
}

.wizard-card-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.35rem;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.wizard-card-subtitle {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
  max-width: none;
  margin: 0;
  font-weight: 400;
}

.wizard-card-content {
  /* Content specific styles in step components */
}

/* ============================================
   WIZARD ACTIONS (BOTTOM BUTTONS)
   ============================================ */

.wizard-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-light);
}

.wizard-actions-next-only {
  justify-content: flex-end;
}

.wizard-btn {
  padding: 0.875rem 2rem;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  letter-spacing: -0.2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.wizard-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.wizard-btn:not(:disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.wizard-btn:not(:disabled):active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.wizard-btn-primary {
  background: var(--primary-color);
  color: var(--white);
}

.wizard-btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--box-shadow);
}

.wizard-btn-secondary {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
}

.wizard-btn-secondary:hover:not(:disabled) {
  background: var(--bg-gray-50);
  border-color: var(--text-primary);
  color: var(--text-primary);
}

/* Progress Bar for Step 1 */
.wizard-progress-bar {
  margin-bottom: 2.5rem;
}

.wizard-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.wizard-progress-text {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.wizard-progress-percentage {
  font-size: 14px;
  font-weight: 600;
  color: #4361ee;
}

.wizard-progress-track {
  height: 8px;
  background: #e9ecef;
  border-radius: 100px;
  overflow: hidden;
}

.wizard-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4361ee 0%, #5a73f5 100%);
  border-radius: 100px;
  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Intent Grid Layout */
.intent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

@media (min-width: 1024px) {
  .intent-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .intent-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .intent-card {
    min-height: 200px;
    padding: 2rem 1.5rem;
  }
}

/* ============================================
   WIZARD PROGRESS BAR
   ============================================ */

.wizard-progress {
  margin-bottom: 1rem;
}

.wizard-progress-bar {
  width: 100%;
  height: 8px;
  background: var(--bg-gray-200);
  border-radius: var(--border-radius-full);
  overflow: hidden;
}

.wizard-progress-fill {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.3s ease;
  border-radius: var(--border-radius-full);
}

.wizard-progress-text {
  display: block;
  margin-top: 0.5rem;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  text-align: center;
}

/* ============================================
   STEPPER (STEP INDICATOR)
   ============================================ */

.wizard-stepper {
  margin-bottom: 0.75rem;
  padding: 0.625rem 1rem;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  border-bottom: 1px solid #e9ecef;
}

.stepper-container {
  display: flex;
  align-items: center;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.25rem 0;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd transparent;
}

.stepper-container::-webkit-scrollbar {
  height: 6px;
}

.stepper-container::-webkit-scrollbar-thumb {
  background-color: #adb5bd;
  border-radius: 3px;
}

.stepper-container::-webkit-scrollbar-track {
  background: transparent;
}

.stepper-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  position: relative;
  flex-shrink: 0;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.stepper-step-indicator {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f3f5;
  border: 2px solid #e9ecef;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.stepper-step.active .stepper-step-indicator {
  background: #4361ee;
  border-color: #4361ee;
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.12);
}

.stepper-step.completed .stepper-step-indicator {
  background: #4285F4;
  border-color: #4285F4;
}

.stepper-step.future .stepper-step-indicator {
  background: #ffffff;
  border-color: #e9ecef;
}

.stepper-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #868e96;
}

.stepper-step.active .stepper-step-icon {
  color: #ffffff;
}

.stepper-step.completed .stepper-step-icon {
  color: #ffffff;
}

.stepper-step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
}

.stepper-step-number-badge {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #868e96;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.stepper-step.active .stepper-step-number-badge {
  color: #4361ee;
}

.stepper-step.completed .stepper-step-number-badge {
  color: #4285F4;
}

.stepper-step-label {
  font-size: 0.75rem;
  color: #495057;
  font-weight: 500;
  white-space: normal;
  overflow-wrap: break-word;
  max-width: 100px;
  text-align: center;
  line-height: 1.2;
}

.stepper-step.active .stepper-step-label {
  color: #212529;
  font-weight: 600;
}

.stepper-step.completed .stepper-step-label {
  color: #495057;
}

/* Clickable stepper steps */
.stepper-step.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.stepper-step.clickable:hover {
  background: #f8f9fa;
}

.stepper-step.clickable:hover .stepper-step-indicator {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(67, 97, 238, 0.15);
}

.stepper-step.clickable:active .stepper-step-indicator {
  transform: translateY(0);
}

.stepper-step.clickable:hover .stepper-step-label {
  color: #4361ee;
}

.stepper-step.future {
  cursor: not-allowed;
  opacity: 0.5;
}

.stepper-step.future .stepper-step-indicator {
  pointer-events: none;
}

.stepper-connector {
  flex: 1 1;
  min-width: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.stepper-connector-line {
  width: 100%;
  height: 2px;
  background-color: #e2e8f0;;
  transition: all 0.3s ease;
}

.stepper-connector.completed {
  background: #4285F4;
}

.stepper-connector.completed .stepper-connector-line {
  background: #4285F4;
}

/* Compact Stepper (Mobile) */
.wizard-stepper-compact {
  padding: 1rem;
  background: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--box-shadow-sm);
  margin-bottom: 1.5rem;
}

.stepper-compact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.stepper-compact-text {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.stepper-compact-percentage {
  font-size: var(--font-size-sm);
  color: var(--primary-color);
  font-weight: var(--font-weight-bold);
}

.stepper-compact-bar {
  width: 100%;
  height: 6px;
  background: var(--bg-gray-200);
  border-radius: var(--border-radius-full);
  overflow: hidden;
}

.stepper-compact-fill {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.3s ease;
  border-radius: var(--border-radius-full);
}

/* ============================================
   INTENT SELECTION CARDS
   ============================================ */

.intent-selection-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 0.5rem;
}

.intent-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  text-align: left;
  min-height: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  position: relative;
  box-shadow: none;
}

.intent-card:hover {
  border-color: var(--border-strong);
  box-shadow: var(--shadow-xs);
  transform: none;
  background: var(--surface-hover);
}

.intent-card.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.intent-card.disabled:hover {
  border-color: var(--border);
  box-shadow: none;
  transform: none;
  background: var(--surface);
}

.intent-card-badge {
  position: absolute;
  top: 10px;
  right: 12px;
  background: var(--warning-muted);
  color: var(--warning);
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  box-shadow: none;
}

.intent-card.selected {
  border-color: var(--primary);
  background: var(--primary-subtle);
  box-shadow: none;
  transform: none;
}

.intent-card.selected::before,
.intent-card.selected::after {
  display: none;
}

.intent-card-icon {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  background: var(--primary-muted);
  border-radius: 8px;
  color: var(--primary);
  transition: background 0.15s ease, color 0.15s ease;
}

.intent-card:hover .intent-card-icon {
  background: var(--primary-muted);
  color: var(--primary);
  transform: none;
}

.intent-card.selected .intent-card-icon {
  background: var(--primary);
  color: #fff;
  transform: none;
  box-shadow: none;
}

.intent-card-body {
  flex: 1 1;
  min-width: 0;
}

.intent-card-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px;
  letter-spacing: -0.01em;
  line-height: 1.35;
  font-family: var(--font-sans, Inter, sans-serif);
}

.intent-card-description {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.45;
  font-weight: 400;
  max-width: none;
  margin: 0;
  font-family: var(--font-sans, Inter, sans-serif);
}

.intent-card-arrow {
  color: var(--text-muted);
  font-size: 16px;
  flex-shrink: 0;
  margin-left: 8px;
}

.intent-card.selected .intent-card-arrow {
  color: var(--primary);
}

/* ============================================
   FORM ELEMENTS
   ============================================ */

.wizard-form-group {
  margin-bottom: 2rem;
  display: block;
  width: 100%;
}

/* Two-column Form Grid - Must come after wizard-form-group */
.wizard-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1.5rem;
  row-gap: 0;
  margin-bottom: 2rem;
  width: 100%;
}

.wizard-form-row > .wizard-form-group {
  margin-bottom: 0;
  width: 100%;
}

.wizard-form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 0.625rem;
  letter-spacing: -0.2px;
}

.wizard-form-label .required {
  color: #dc3545;
  margin-left: 0.25rem;
  font-weight: 700;
}

.wizard-form-label-row {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-bottom: 0.625rem;
}

.wizard-form-label-row .wizard-form-label {
  display: inline;
  margin-bottom: 0;
  line-height: 1.25;
}

.wizard-help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(33, 150, 243, 0.12);
  color: #1976d2;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  cursor: help;
  position: relative;
  top: 0;
  -webkit-user-select: none;
          user-select: none;
}

.wizard-help-icon:focus {
  outline: 2px solid rgba(25, 118, 210, 0.35);
  outline-offset: 2px;
}

.wizard-help-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #212529;
  color: #fff;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.4;
  white-space: normal;
  width: max-content;
  max-width: 260px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 20;
}

.wizard-help-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #212529;
}

.wizard-help-icon:hover .wizard-help-tooltip,
.wizard-help-icon:focus .wizard-help-tooltip,
.wizard-help-icon:focus-within .wizard-help-tooltip {
  opacity: 1;
  visibility: visible;
}

.wizard-form-input,
.wizard-form-select,
.wizard-form-textarea {
  width: 100%;
  padding: 0.875rem 1.125rem;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 400;
  color: #212529;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wizard-form-input::placeholder,
.wizard-form-select::placeholder,
.wizard-form-textarea::placeholder {
  color: #adb5bd;
  font-weight: 400;
}

.wizard-form-input:hover,
.wizard-form-select:hover,
.wizard-form-textarea:hover {
  border-color: #adb5bd;
}

.wizard-form-input:focus,
.wizard-form-select:focus,
.wizard-form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.08);
  background: #ffffff;
}

.wizard-form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1.125rem center;
  padding-right: 3rem;
  appearance: none;
  cursor: pointer;
}

.wizard-form-textarea {
  min-height: 120px;
  resize: vertical;
  line-height: 1.6;
}

.wizard-form-help {
  font-size: 13px;
  color: #6c757d;
  margin-top: 0.5rem;
  line-height: 1.4;
  font-weight: 400;
}

.wizard-form-error {
  font-size: 13px;
  color: #dc3545;
  margin-top: 0.5rem;
  font-weight: 500;
}

/* Error state for form inputs */
.wizard-form-input.error,
.wizard-form-select.error,
.wizard-form-textarea.error {
  border-color: #dc3545;
  background: #fff8f9;
}

.wizard-form-input.error:focus,
.wizard-form-select.error:focus,
.wizard-form-textarea.error:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.08);
}

/* Checkbox/Radio - Professional */
.wizard-form-checkbox,
.wizard-form-radio {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.875rem;
}

.wizard-form-checkbox input,
.wizard-form-radio input {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-top: 2px;
  accent-color: var(--primary-color);
}

.wizard-form-checkbox label,
.wizard-form-radio label {
  font-size: 15px;
  color: #212529;
  cursor: pointer;
  font-weight: 400;
  line-height: 1.5;
}

/* File Upload */
.wizard-file-upload {
  border: 2px dashed var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  text-align: center;
  transition: all 0.2s ease;
  cursor: pointer;
}

.wizard-file-upload:hover {
  border-color: var(--primary-color);
  background: rgba(67, 97, 238, 0.02);
}

.wizard-file-upload-icon {
  font-size: 3rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

.wizard-file-upload-text {
  font-size: var(--font-size-md);
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.wizard-file-upload-hint {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

/* ============================================
   STEP 4 PATH SELECTOR & CARDS (New)
   ============================================ */

/* Path Selector Cards (Connect/Upload/Create) */
.wizard-path-card {
  background: var(--white);
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: 1.5rem 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.wizard-path-card:hover {
  border-color: var(--primary-color);
  box-shadow: var(--box-shadow-md);
  transform: translateY(-2px);
}

.wizard-path-card.active {
  border-color: var(--primary-color);
  background: rgba(67, 97, 238, 0.05);
  box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.1);
}

.wizard-path-icon {
  font-size: 2.5rem;
  margin-bottom: 0.25rem;
}

.wizard-path-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: 0;
}

.wizard-path-description {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  margin: 0;
}

.wizard-path-content {
  margin-top: 1.5rem;
}

/* Template Selection Cards */
.wizard-template-card {
  background: var(--white);
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius-md);
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.wizard-template-card:hover {
  border-color: var(--primary-color);
  box-shadow: var(--box-shadow);
  transform: translateY(-2px);
}

.wizard-template-card.active {
  border-color: var(--primary-color);
  background: rgba(67, 97, 238, 0.05);
  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);
}

/* Small Button Variant */
.wizard-btn-sm {
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid var(--border-color);
  background: var(--white);
  color: var(--text-secondary);
}

.wizard-btn-sm.wizard-btn-primary {
  background: var(--primary-color);
  color: var(--white);
  border-color: var(--primary-color);
}

.wizard-btn-sm.wizard-btn-secondary {
  background: transparent;
  color: var(--text-secondary);
  border-color: var(--border-color);
}

.wizard-btn-sm:hover:not(:disabled) {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.wizard-btn-sm.wizard-btn-primary:hover:not(:disabled) {
  background: var(--primary-hover);
  color: var(--white);
}

/* ============================================
   LOADING & PROGRESS
   ============================================ */

.wizard-loading {
  text-align: center;
  padding: 3rem;
}

.wizard-loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid var(--bg-gray-200);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Lucide Icon Spinner */
.spinner {
  animation: spin 1s linear infinite;
  display: inline-block;
}

/* Separate from .spinner, which other stylesheets give width/border/margin */
.icon-spin {
  animation: spin 1s linear infinite;
  display: block;
}

/* ============================================
   MODE SELECTION CARDS (Step 5)
   ============================================ */

.wizard-mode-card {
  padding: 2rem 1.5rem;
  background-color: var(--card-bg);
  border: 2px solid var(--border-color);
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
}

.wizard-mode-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.wizard-mode-card.selected {
  border-color: var(--primary-color);
  background-color: var(--primary-color-light);
  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.2);
}

.wizard-mode-card.recommended {
  border-color: var(--success-color);
}

.wizard-recommended-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.375rem 0.75rem;
  background-color: var(--success-color);
  color: #fff;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

/* ============================================
   WARNING MODAL (Step 5)
   ============================================ */

.wizard-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease;
}

.wizard-modal {
  background-color: var(--card-bg);
  border-radius: 16px;
  padding: 2rem;
  max-width: 560px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s ease;
  position: relative;
  z-index: 10001;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.wizard-loading-text {
  font-size: var(--font-size-lg);
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.wizard-loading-subtext {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.spinner-small {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid var(--white);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

/* Progress Stages */
.wizard-progress-stages {
  margin-top: 2rem;
}

.wizard-progress-stage {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-gray-50);
  border-radius: var(--border-radius-md);
  margin-bottom: 0.75rem;
}

.wizard-progress-stage.active {
  background: rgba(67, 97, 238, 0.1);
}

.wizard-progress-stage.completed {
  background: rgba(76, 201, 240, 0.1);
}

.wizard-progress-stage-icon {
  font-size: 1.5rem;
}

.wizard-progress-stage-text {
  flex: 1 1;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

/* Logs Display */
.wizard-logs {
  background: #1e1e1e;
  border-radius: var(--border-radius-md);
  padding: 1.5rem;
  max-height: 400px;
  overflow-y: auto;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: var(--font-size-sm);
}

.wizard-log-line {
  color: #d4d4d4;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}

.wizard-log-line.info {
  color: #4fc1ff;
}

.wizard-log-line.success {
  color: #4cc9f0;
}

.wizard-log-line.error {
  color: #f72585;
}

.wizard-log-line.warning {
  color: #f8961e;
}

/* ============================================
   RESPONSIVE
   ============================================ */

@media (max-width: 768px) {
  .wizard-header {
    padding: 0.75rem 1rem;
  }

  .wizard-main {
    padding: 0.75rem;
    max-height: calc(100vh - 70px);
  }

  .wizard-container {
    padding: 0 1rem;
  }

  .wizard-card {
    padding: 1rem;
  }

  .wizard-card-title {
    font-size: var(--font-size-xl);
  }

  .wizard-stepper {
    padding: 0.5rem 0.75rem;
    margin-bottom: 0.5rem;
  }

  .stepper-step {
    padding: 0.25rem 0.375rem;
  }

  .stepper-step-indicator {
    width: 28px;
    height: 28px;
  }

  .stepper-step-label {
    font-size: 0.6875rem;
    max-width: 80px;
  }

  .stepper-connector {
    min-width: 8px;
  }

  .intent-selection-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .intent-card {
    min-height: 140px;
    padding: 1rem;
  }

  .wizard-actions {
    flex-direction: column-reverse;
    margin-top: 1rem;
    padding-top: 1rem;
  }

  .wizard-btn {
    width: 100%;
    justify-content: center;
  }

  .stepper-container {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 0.5rem;
    scroll-snap-type: x proximity;
  }

  .stepper-step {
    scroll-snap-align: center;
  }

  .wizard-header-actions {
    gap: 0.5rem;
  }

  .wizard-exit-btn,
  .wizard-save-exit-btn,
  .wizard-back-btn {
    padding: 0.5rem 0.75rem;
    font-size: var(--font-size-xs);
  }
}

/* ============================================
   AUTH TABS (Login/Signup Switcher)
   ============================================ */

.wizard-auth-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid var(--border-color);
}

.wizard-auth-tab {
  flex: 1 1;
  padding: 0.875rem 1rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.wizard-auth-tab:hover {
  color: var(--text-primary);
  background: rgba(67, 97, 238, 0.02);
}

.wizard-auth-tab.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
  background: rgba(67, 97, 238, 0.05);
}

.wizard-auth-content {
  min-height: 420px;
  max-height: 500px;
  overflow-y: auto;
  padding: 0.5rem 0;
}

.wizard-auth-progress {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-light);
}

/* ============================================
   UTILITY CLASSES
   ============================================ */

.wizard-text-center {
  text-align: center;
}

.wizard-mt-1 { margin-top: 0.5rem; }
.wizard-mt-2 { margin-top: 1rem; }
.wizard-mt-3 { margin-top: 1.5rem; }
.wizard-mt-4 { margin-top: 2rem; }

.wizard-mb-1 { margin-bottom: 0.5rem; }
.wizard-mb-2 { margin-bottom: 1rem; }
.wizard-mb-3 { margin-bottom: 1.5rem; }
.wizard-mb-4 { margin-bottom: 2rem; }

/* ============================================
   STEP 5: AI PREVIEW & EDITING STYLES
   ============================================ */

/* Statistics Dashboard */
.ai-preview-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.ai-preview-stat-card {
  background: white;
  border: 2px solid var(--primary-color);
  border-radius: var(--border-radius-md);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: var(--box-shadow-sm);
  transition: all 0.3s ease;
}

.ai-preview-stat-card:hover {
  box-shadow: var(--box-shadow-md);
  border-color: var(--primary-dark);
}

.ai-preview-stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  background: rgba(67, 97, 238, 0.1);
  border-radius: var(--border-radius-md);
  color: var(--primary-color);
}

.ai-preview-stat-icon svg {
  display: block;
}

.ai-preview-stat-content {
  flex: 1 1;
}

.ai-preview-stat-value {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 0.25rem;
  color: var(--primary-color);
}

.ai-preview-stat-label {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

/* AI Insights Panel */
.ai-preview-insights {
  background: #e3f2fd;
  border: 1px solid #90caf9;
  border-left: 4px solid var(--primary-color);
  border-radius: var(--border-radius-md);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.ai-preview-insights-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.ai-preview-insights-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  color: var(--primary-color);
}

.ai-preview-insights-icon {
  font-size: 1.5rem;
}

.ai-preview-insights-close {
  background: transparent;
  border: none;
  color: var(--text-secondary);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.ai-preview-insights-close:hover {
  background: rgba(67, 97, 238, 0.1);
  color: var(--primary-color);
}

.ai-preview-insights-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ai-preview-insight-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.ai-preview-insight-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.ai-preview-insight-badge.success {
  background: rgba(76, 175, 80, 0.9);
}

.ai-preview-insight-badge.warning {
  background: rgba(255, 152, 0, 0.9);
}

.ai-preview-insight-badge.info {
  background: rgba(33, 150, 243, 0.9);
}

/* Action Toolbar */
.ai-preview-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--bg-light);
  border-radius: var(--border-radius-md);
  border: 1px solid var(--border-color);
}

.ai-preview-toolbar-left,
.ai-preview-toolbar-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.ai-preview-toolbar-btn {
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color);
  background: white;
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ai-preview-toolbar-btn:hover {
  background: var(--bg-light);
  border-color: var(--primary-color);
}

.ai-preview-toolbar-btn.primary {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.ai-preview-toolbar-btn.primary:hover {
  background: var(--primary-dark);
  border-color: var(--primary-dark);
}

.ai-preview-toolbar-btn.danger {
  color: var(--danger-color);
  border-color: var(--danger-color);
}

.ai-preview-toolbar-btn.danger:hover {
  background: var(--danger-color);
  color: white;
}

.ai-preview-filter {
  padding: 0.5rem 1rem;
  border: 1px solid var(--border-color);
  background: white;
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.ai-preview-filter:hover,
.ai-preview-filter:focus {
  border-color: var(--primary-color);
  outline: none;
}

.ai-preview-view-toggle {
  display: flex;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  overflow: hidden;
}

.ai-preview-view-btn {
  background: white;
  border: none;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-right: 1px solid var(--border-color);
}

.ai-preview-view-btn:last-child {
  border-right: none;
}

.ai-preview-view-btn.active {
  background: var(--primary-color);
  color: white;
}

.ai-preview-view-btn:hover:not(.active) {
  background: var(--bg-light);
}

/* Cases Container */
.ai-preview-cases-container {
  margin-bottom: 2rem;
}

.ai-preview-select-all {
  padding: 0.75rem 1rem;
  background: var(--bg-light);
  border: 1px solid var(--border-color);
  border-bottom: none;
  border-radius: var(--border-radius-md) var(--border-radius-md) 0 0;
}

.ai-preview-checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.ai-preview-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.ai-preview-cases {
  border: 1px solid var(--border-color);
  border-radius: 0 0 var(--border-radius-md) var(--border-radius-md);
  overflow: hidden;
}

.ai-preview-cases.grid-view {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1rem;
  padding: 1rem;
  background: var(--bg-light);
}

.ai-preview-cases.list-view {
  display: flex;
  flex-direction: column;
}

/* Test Case Card */
.ai-preview-case {
  background: white;
  border-bottom: 1px solid var(--border-color);
  transition: all 0.3s ease;
}

.ai-preview-cases.grid-view .ai-preview-case {
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  overflow: hidden;
}

.ai-preview-cases.list-view .ai-preview-case:last-child {
  border-bottom: none;
}

.ai-preview-case.selected {
  background: #f0f4ff;
  border-color: var(--primary-color);
}

.ai-preview-case.expanded {
  box-shadow: var(--box-shadow-md);
}

.ai-preview-case-header {
  display: flex;
  align-items: start;
  gap: 1rem;
  padding: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ai-preview-case-header:hover {
  background: var(--bg-lighter);
}

.ai-preview-case-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ai-preview-case-header-left input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.ai-preview-case-number {
  font-weight: 600;
  color: var(--text-secondary);
  min-width: 30px;
}

.ai-preview-case-header-center {
  flex: 1 1;
  min-width: 0;
}

.ai-preview-case-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
  cursor: text;
}

.ai-preview-case-name:hover {
  color: var(--primary-color);
}

.ai-preview-case-name-input {
  width: 100%;
  padding: 0.25rem 0.5rem;
  border: 2px solid var(--primary-color);
  border-radius: var(--border-radius-sm);
  font-size: 1rem;
  font-weight: 600;
  font-family: inherit;
}

.ai-preview-case-meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.ai-preview-case-steps {
  font-weight: 500;
}

.ai-preview-case-dot {
  opacity: 0.5;
}

.ai-preview-priority-select {
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  background: white;
}

.ai-preview-priority-select.priority-high {
  color: var(--danger-color);
  border-color: var(--danger-color);
  background: rgba(244, 67, 54, 0.1);
}

.ai-preview-priority-select.priority-medium {
  color: var(--warning-color);
  border-color: var(--warning-color);
  background: rgba(255, 152, 0, 0.1);
}

.ai-preview-priority-select.priority-low {
  color: var(--success-color);
  border-color: var(--success-color);
  background: rgba(76, 175, 80, 0.1);
}

.ai-preview-case-header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.ai-preview-case-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ai-preview-tag {
  padding: 0.25rem 0.75rem;
  background: rgba(67, 97, 238, 0.1);
  color: var(--primary-color);
  border-radius: var(--border-radius-full);
  font-size: 0.75rem;
  font-weight: 500;
}

.ai-preview-case-actions {
  display: flex;
  gap: 0.25rem;
}

.ai-preview-action-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.ai-preview-action-btn:hover {
  background: var(--bg-light);
  border-color: var(--primary-color);
}

/* Case Details (Expanded) */
.ai-preview-case-details {
  padding: 0 1rem 1rem 4rem;
  border-top: 1px solid var(--border-light);
  background: var(--bg-lighter);
}

.ai-preview-steps-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
}

.ai-preview-steps-header h5 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.ai-preview-add-step-btn {
  padding: 0.375rem 0.75rem;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ai-preview-add-step-btn:hover {
  background: var(--primary-dark);
}

.ai-preview-steps {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ai-preview-step {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
}

.ai-preview-step-number {
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary-color);
  color: white;
  border-radius: 50%;
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.ai-preview-step-content {
  flex: 1 1;
  min-width: 0;
}

.ai-preview-step-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ai-preview-step-action,
.ai-preview-step-expected {
  font-size: 0.9rem;
  line-height: 1.5;
}

.ai-preview-step-action strong,
.ai-preview-step-expected strong {
  color: var(--text-secondary);
  font-weight: 600;
  margin-right: 0.5rem;
}

.ai-preview-step-field {
  margin-bottom: 0.75rem;
}

.ai-preview-step-field label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.ai-preview-step-field input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  font-size: 0.9rem;
  transition: border-color 0.3s ease;
}

.ai-preview-step-field input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.ai-preview-step-save {
  padding: 0.5rem 1rem;
  background: var(--success-color);
  color: white;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
}

.ai-preview-step-save:hover {
  background: #388e3c;
}

.ai-preview-step-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.ai-preview-step-action-btn {
  padding: 0.375rem 0.75rem;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}

.ai-preview-step-action-btn:hover {
  background: var(--bg-light);
  border-color: var(--primary-color);
}

.ai-preview-step-action-btn.danger:hover {
  background: var(--danger-color);
  color: white;
  border-color: var(--danger-color);
}

/* Empty State */
.ai-preview-empty {
  padding: 3rem;
  text-align: center;
  color: var(--text-secondary);
}

.ai-preview-empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ai-preview-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .ai-preview-toolbar {
    flex-direction: column;
    gap: 1rem;
  }

  .ai-preview-toolbar-left,
  .ai-preview-toolbar-right {
    width: 100%;
    justify-content: space-between;
  }

  .ai-preview-cases.grid-view {
    grid-template-columns: 1fr;
  }

  .ai-preview-case-header {
    flex-wrap: wrap;
  }

  .ai-preview-case-details {
    padding: 0 0.5rem 1rem 0.5rem;
  }
}

@media (max-width: 480px) {
  .ai-preview-stats {
    grid-template-columns: 1fr;
  }

  .ai-preview-case-header-right {
    width: 100%;
    justify-content: space-between;
  }
}

/* ============================================
   REQUIREMENT TRACEABILITY STYLES
   ============================================ */

/* Traceability Toggle Button */
.ai-preview-traceability-toggle {
  margin-bottom: 1.5rem;
  text-align: center;
}

.ai-preview-traceability-btn {
  padding: 0.75rem 1.5rem;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: var(--box-shadow-sm);
}

.ai-preview-traceability-btn:hover {
  background: var(--primary-dark);
  box-shadow: var(--box-shadow-md);
}

.ai-preview-traceability-btn.active {
  background: var(--primary-dark);
}

.ai-preview-traceability-btn .ai-preview-badge {
  background: rgba(255, 255, 255, 0.25);
  padding: 0.25rem 0.5rem;
  border-radius: var(--border-radius-full);
  font-size: 0.75rem;
  margin-left: 0.25rem;
}

/* Traceability Panel */
.ai-preview-traceability-panel {
  background: #f0f4ff;
  border: 1px solid #d0ddff;
  border-left: 4px solid var(--primary-color);
  border-radius: var(--border-radius-lg);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.ai-preview-traceability-header {
  margin-bottom: 1.5rem;
}

.ai-preview-traceability-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
}

.ai-preview-traceability-subtitle {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0;
}

.ai-preview-requirements-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ai-preview-requirement-card {
  background: white;
  border-radius: var(--border-radius-md);
  padding: 1rem;
  box-shadow: var(--box-shadow-sm);
  transition: all 0.3s ease;
}

.ai-preview-requirement-card:hover {
  box-shadow: var(--box-shadow-md);
  transform: translateX(4px);
}

.ai-preview-requirement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.ai-preview-requirement-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.ai-preview-requirement-badge {
  padding: 0.25rem 0.75rem;
  border-radius: var(--border-radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.ai-preview-requirement-badge.jira_epic,
.ai-preview-requirement-badge.jira_story {
  background: #0052cc;
  color: white;
}

.ai-preview-requirement-badge.uploaded_doc {
  background: #ff9800;
  color: white;
}

.ai-preview-requirement-badge.requirements_lite {
  background: #4caf50;
  color: white;
}

.ai-preview-requirement-key {
  font-weight: 600;
  color: var(--primary-color);
  font-size: 0.9rem;
}

.ai-preview-requirement-title {
  color: var(--text-primary);
  font-size: 0.9rem;
}

.ai-preview-requirement-coverage {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 200px;
}

.ai-preview-requirement-coverage-bar {
  flex: 1 1;
  height: 8px;
  background: #e0e0e0;
  border-radius: var(--border-radius-full);
  overflow: hidden;
}

.ai-preview-requirement-coverage-fill {
  height: 100%;
  background: var(--primary-color);
  transition: width 0.5s ease;
}

.ai-preview-requirement-coverage-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

/* Requirement Badge on Test Case */
.ai-preview-req-badge {
  padding: 0.25rem 0.5rem;
  background: var(--primary-color);
  color: white;
  border-radius: var(--border-radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* Mapping Panel */
.ai-preview-mapping-panel {
  padding: 1rem;
  background: #f8f9fa;
  border-top: 2px solid var(--primary-color);
  border-bottom: 1px solid var(--border-light);
}

.ai-preview-mapping-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.ai-preview-mapping-header h5 {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.ai-preview-mapping-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: var(--text-secondary);
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.ai-preview-mapping-close:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--text-primary);
}

.ai-preview-mapping-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
}

.ai-preview-mapping-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: white;
  border: 2px solid var(--border-color);
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: all 0.3s ease;
}

.ai-preview-mapping-item:hover {
  border-color: var(--primary-color);
  background: #f0f4ff;
}

.ai-preview-mapping-item.mapped {
  border-color: var(--success-color);
  background: #f1f8f4;
}

.ai-preview-mapping-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.ai-preview-mapping-req-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ai-preview-mapping-badge {
  padding: 0.2rem 0.6rem;
  border-radius: var(--border-radius-full);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}

.ai-preview-mapping-badge.jira_epic,
.ai-preview-mapping-badge.jira_story {
  background: #0052cc;
  color: white;
}

.ai-preview-mapping-badge.uploaded_doc {
  background: #ff9800;
  color: white;
}

.ai-preview-mapping-badge.requirements_lite {
  background: #4caf50;
  color: white;
}

.ai-preview-mapping-key {
  font-weight: 600;
  color: var(--primary-color);
  font-size: 0.85rem;
}

.ai-preview-mapping-title {
  color: var(--text-primary);
  font-size: 0.85rem;
}

.ai-preview-mapping-check {
  color: var(--success-color);
  font-size: 1.25rem;
  font-weight: bold;
}

/* Linked Requirements Display */
.ai-preview-linked-requirements {
  padding: 1rem;
  background: #f0f4ff;
  border-left: 4px solid var(--primary-color);
  border-radius: var(--border-radius-sm);
  margin-bottom: 1rem;
}

.ai-preview-linked-requirements h5 {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ai-preview-linked-requirements h5::before {
  content: "🔗";
  font-size: 1rem;
}

.ai-preview-linked-req-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ai-preview-linked-req {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: white;
  border-radius: var(--border-radius-sm);
  flex-wrap: wrap;
}

.ai-preview-linked-req-badge {
  padding: 0.2rem 0.6rem;
  border-radius: var(--border-radius-full);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
}

.ai-preview-linked-req-badge.jira_epic,
.ai-preview-linked-req-badge.jira_story {
  background: #0052cc;
  color: white;
}

.ai-preview-linked-req-badge.uploaded_doc {
  background: #ff9800;
  color: white;
}

.ai-preview-linked-req-badge.requirements_lite {
  background: #4caf50;
  color: white;
}

.ai-preview-linked-req-key {
  font-weight: 600;
  color: var(--primary-color);
  font-size: 0.85rem;
}

.ai-preview-linked-req-title {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

/* Responsive */
@media (max-width: 768px) {
  .ai-preview-requirement-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .ai-preview-requirement-coverage {
    width: 100%;
  }

  .ai-preview-mapping-req-info {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* ============================================
   WORKSPACE FORM - NEW STYLES
   ============================================ */

/* Two-column grid layout for workspace form */
.wizard-workspace-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.wizard-workspace-form-group {
  display: flex;
  flex-direction: column;
}

.wizard-workspace-form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.wizard-workspace-form-group label .required {
  color: #ef4444;
  margin-left: 0.25rem;
  font-weight: 700;
}

.wizard-workspace-form-group input,
.wizard-workspace-form-group select {
  width: 100%;
  padding: 0.5rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #111827;
  transition: all 0.2s ease;
  background: #ffffff;
  font-family: inherit;
}

.wizard-workspace-form-group input:disabled,
.wizard-workspace-form-group select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
  border-color: #e5e7eb;
}

.wizard-workspace-form-group input:focus,
.wizard-workspace-form-group select:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1), 0 0 0 1px #3b82f6;
  border-color: #3b82f6;
}

/* Ensure select option styling doesn't affect border */
.wizard-workspace-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1rem;
  padding-right: 2.5rem;
}

.wizard-workspace-form-group p {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

.wizard-workspace-form-group p.error {
  color: #ef4444;
}

/* Edit mode header with edit icon */
.wizard-workspace-edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.wizard-workspace-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #2563eb;
  background: transparent;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.wizard-workspace-edit-btn:hover {
  background-color: #eff6ff;
  color: #1d4ed8;
}

.wizard-workspace-edit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Update/Cancel button group in edit header */
.wizard-workspace-edit-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.wizard-workspace-edit-actions button {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.wizard-workspace-edit-actions button.primary {
  color: white;
  background-color: #2563eb;
}

.wizard-workspace-edit-actions button.primary:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.wizard-workspace-edit-actions button.primary:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.wizard-workspace-edit-actions button.secondary {
  color: #374151;
  background: transparent;
  border: 1px solid #d1d5db;
}

.wizard-workspace-edit-actions button.secondary:hover:not(:disabled) {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.wizard-workspace-edit-actions button.secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Action buttons for workspace */
.wizard-workspace-actions {
  display: flex;
  gap: 0.75rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.wizard-workspace-actions button {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.wizard-workspace-actions button.back {
  color: #374151;
  border: 1px solid #d1d5db;
  background: white;
}

.wizard-workspace-actions button.back:hover {
  background-color: #f3f4f6;
}

.wizard-workspace-actions button.back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wizard-workspace-actions button.primary {
  color: white;
  background-color: #2563eb;
  margin-left: auto;
}

.wizard-workspace-actions button.primary:hover {
  background-color: #1d4ed8;
}

.wizard-workspace-actions button.primary:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.wizard-workspace-actions button.secondary {
  color: #374151;
  border: 1px solid #d1d5db;
  background: white;
}

.wizard-workspace-actions button.secondary:hover {
  background-color: #f3f4f6;
}

.wizard-workspace-actions button.secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive: Stack on mobile */
@media (max-width: 768px) {
  .wizard-workspace-form {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .wizard-workspace-actions {
    flex-direction: column-reverse;
  }

  .wizard-workspace-actions button.primary {
    margin-left: 0;
    width: 100%;
  }

  .wizard-workspace-actions button.back {
    width: 100%;
  }
}
/* Project Edit Styles - Similar to Workspace */
.wizard-project-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.wizard-project-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #2563eb;
  background: transparent;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.wizard-project-edit-btn:hover {
  background-color: #eff6ff;
  color: #1d4ed8;
}

.wizard-project-edit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Update/Cancel button group in project edit header */
.wizard-project-edit-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.wizard-project-edit-actions button {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.wizard-project-edit-actions button.primary {
  color: white;
  background-color: #2563eb;
}

.wizard-project-edit-actions button.primary:hover:not(:disabled) {
  background-color: #1d4ed8;
}

.wizard-project-edit-actions button.primary:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.wizard-project-edit-actions button.secondary {
  color: #374151;
  background: transparent;
  border: 1px solid #d1d5db;
}

.wizard-project-edit-actions button.secondary:hover:not(:disabled) {
  background-color: #f3f4f6;
  border-color: #9ca3af;
}

.wizard-project-edit-actions button.secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Action buttons for project */
.wizard-project-actions {
  display: flex;
  gap: 0.75rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.wizard-project-actions button {
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem; 
  font-weight: 500;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.wizard-project-actions button.back {
  color: #374151;
  border: 1px solid #d1d5db;
  background: white;
}

.wizard-project-actions button.back:hover {
  background-color: #f3f4f6;
}

.wizard-project-actions button.back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wizard-project-actions button.primary {
  color: white;
  background-color: #2563eb;
  margin-left: auto;
}

.wizard-project-actions button.primary:hover {
  background-color: #1d4ed8;
}

.wizard-project-actions button.primary:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

.wizard-project-actions button.secondary {
  color: #374151;
  border: 1px solid #d1d5db;
  background: white;
}

.wizard-project-actions button.secondary:hover {
  background-color: #f3f4f6;
}

.wizard-project-actions button.secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive: Stack on mobile */
@media (max-width: 768px) {
  .wizard-project-section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .wizard-project-actions {
    flex-direction: column-reverse;
  }

  .wizard-project-actions button.primary {
    margin-left: 0;
    width: 100%;
  }

  .wizard-project-actions button.back {
    width: 100%;
  }
}
/* ============================================
   DISCOVERY SCREENSHOT GALLERY (Step 10C)
   ============================================ */

.discovery-screenshot-gallery {
  margin-bottom: 2rem;
}

.discovery-screenshot-header {
  margin-bottom: 1rem;
}

.discovery-screenshot-heading {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.discovery-screenshot-count {
  display: inline-flex;
  align-items: center;
  margin-left: 0.25rem;
  padding: 0.1rem 0.55rem;
  border-radius: 999px;
  background: rgba(67, 97, 238, 0.1);
  color: var(--primary-color);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.4;
}

.discovery-screenshot-subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.discovery-screenshot-panel {
  padding: 1.5rem;
  background-color: var(--card-bg, var(--white));
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

/* Grid: four cards per row on desktop, fewer on smaller screens */
.discovery-screenshot-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

@media (max-width: 1024px) {
  .discovery-screenshot-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .discovery-screenshot-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .discovery-screenshot-panel {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .discovery-screenshot-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Card */
.discovery-screenshot-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: var(--card-bg, var(--white));
  border: 1px solid var(--border-color);
  border-radius: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.discovery-screenshot-card:hover,
.discovery-screenshot-card:focus-within {
  z-index: 10;
  transform: translateY(-2px);
  border-color: rgba(67, 97, 238, 0.45);
  box-shadow: var(--box-shadow-md);
}

.discovery-screenshot-card.is-skeleton {
  pointer-events: none;
}

.discovery-screenshot-thumb {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 10;
  padding: 0;
  border: none;
  border-bottom: 1px solid var(--border-light);
  border-radius: 9px 9px 0 0;
  background: var(--bg-gray-100);
  overflow: hidden;
  cursor: pointer;
}

.discovery-screenshot-thumb:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--primary-color);
}

.discovery-screenshot-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.35s ease;
}

.discovery-screenshot-img.is-loaded {
  opacity: 1;
}

.discovery-screenshot-card:hover .discovery-screenshot-img.is-loaded {
  transform: scale(1.03);
}

.discovery-screenshot-skeleton-block,
.discovery-screenshot-skeleton-line {
  display: block;
  background: linear-gradient(90deg, #eef1f5 25%, #f8f9fb 50%, #eef1f5 75%);
  background-size: 200% 100%;
  animation: discovery-shimmer 1.4s ease-in-out infinite;
}

.discovery-screenshot-skeleton-block {
  position: absolute;
  inset: 0;
}

.discovery-screenshot-skeleton-line {
  width: 70%;
  height: 0.8rem;
  border-radius: 4px;
}

.discovery-screenshot-fallback {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 500;
  background: repeating-linear-gradient(45deg, #f3f4f6, #f3f4f6 10px, #eceff3 10px, #eceff3 20px);
}

.discovery-screenshot-zoom {
  position: absolute;
  right: 0.5rem;
  bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.25rem 0.6rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.78);
  color: var(--white);
  font-size: 0.7rem;
  font-weight: 600;
  opacity: 0;
  transform: translateY(4px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
}

.discovery-screenshot-card:hover .discovery-screenshot-zoom,
.discovery-screenshot-card:focus-within .discovery-screenshot-zoom {
  opacity: 1;
  transform: translateY(0);
}

/* URL path + tooltip */
.discovery-screenshot-path {
  position: relative;
  padding: 0.6rem 0.75rem;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
  font-size: 0.74rem;
  line-height: 1.4;
  color: var(--text-secondary);
  border-radius: 0 0 9px 9px;
}

.discovery-screenshot-path.has-tooltip {
  cursor: help;
}

.discovery-screenshot-path:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: -2px;
}

.discovery-screenshot-path-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.discovery-screenshot-tooltip {
  position: absolute;
  left: 0.5rem;
  right: 0.5rem;
  bottom: calc(100% + 6px);
  z-index: 20;
  padding: 0.5rem 0.65rem;
  border-radius: 6px;
  background: #0f172a;
  color: #f8fafc;
  font-size: 0.72rem;
  line-height: 1.45;
  white-space: normal;
  word-break: break-all;
  box-shadow: var(--box-shadow-md);
  opacity: 0;
  visibility: hidden;
  transform: translateY(4px);
  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s;
  pointer-events: none;
}

.discovery-screenshot-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 1rem;
  border: 6px solid transparent;
  border-top-color: #0f172a;
}

.discovery-screenshot-path:hover .discovery-screenshot-tooltip,
.discovery-screenshot-path:focus .discovery-screenshot-tooltip,
.discovery-screenshot-path:focus-visible .discovery-screenshot-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Empty / error states */
.discovery-screenshot-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2.5rem 1rem;
  text-align: center;
  color: var(--text-secondary);
}

.discovery-screenshot-state svg {
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.discovery-screenshot-state.is-error svg {
  color: var(--danger-color);
}

.discovery-screenshot-state strong {
  font-size: 0.95rem;
  color: var(--text-primary);
}

.discovery-screenshot-state span {
  max-width: 420px;
  font-size: 0.85rem;
}

.discovery-screenshot-state .wizard-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.75rem;
}

/* Infinite scroll footer */
.discovery-screenshot-sentinel {
  width: 100%;
  height: 1px;
}

.discovery-screenshot-footer {
  display: flex;
  justify-content: center;
  padding-top: 1.25rem;
  min-height: 1.5rem;
}

.discovery-screenshot-footer-status {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.discovery-screenshot-footer-status.is-error {
  color: var(--danger-color);
}

.discovery-screenshot-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0;
  border: none;
  background: none;
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}

.discovery-screenshot-link-btn:hover {
  text-decoration: underline;
}

/* Full-screen preview */
.discovery-lightbox {
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  background: rgba(2, 6, 23, 0.92);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: discovery-fade-in 0.18s ease;
}

.discovery-lightbox-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-shrink: 0;
  padding: 0.85rem 1.25rem;
  color: #e2e8f0;
}

.discovery-lightbox-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-width: 0;
}

.discovery-lightbox-path {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
  font-size: 0.875rem;
}

.discovery-lightbox-counter {
  flex-shrink: 0;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 0.75rem;
  font-weight: 600;
}

.discovery-lightbox-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.discovery-lightbox-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  height: 38px;
  min-width: 38px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease;
}

.discovery-lightbox-icon-btn.is-labelled {
  padding: 0 0.9rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.discovery-lightbox-icon-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}

.discovery-lightbox-icon-btn:focus-visible {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}

.discovery-lightbox-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0 1rem 1rem;
}

.discovery-lightbox-nav {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: var(--white);
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.discovery-lightbox-nav:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.discovery-lightbox-nav:focus-visible {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}

.discovery-lightbox-nav:disabled {
  opacity: 0.25;
  cursor: default;
}

.discovery-lightbox-figure {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  margin: 0;
  display: flex;
  overflow: auto;
}

.discovery-lightbox-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
}

/* \`margin: auto\` centers the image but never pushes its top out of reach when it is taller than the viewport */
.discovery-lightbox-img {
  display: block;
  margin: auto;
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.25s ease;
}

.discovery-lightbox-figure.is-fit .discovery-lightbox-img {
  max-height: 100%;
  object-fit: contain;
  cursor: zoom-in;
}

.discovery-lightbox-figure.is-width .discovery-lightbox-img {
  cursor: zoom-out;
}

.discovery-lightbox-img.is-loaded {
  opacity: 1;
}

.discovery-lightbox-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  max-width: 420px;
  margin: auto;
  color: #cbd5e1;
  text-align: center;
}

.discovery-lightbox-error strong {
  color: var(--white);
  font-size: 1rem;
}

.discovery-lightbox-error span {
  font-size: 0.85rem;
}

.discovery-lightbox-hint {
  flex-shrink: 0;
  padding: 0 1rem 0.75rem;
  text-align: center;
  font-size: 0.72rem;
  color: rgba(226, 232, 240, 0.6);
}

@media (max-width: 768px) {
  .discovery-lightbox-topbar {
    padding: 0.65rem 0.75rem;
  }

  .discovery-lightbox-icon-btn.is-labelled span {
    display: none;
  }

  .discovery-lightbox-icon-btn.is-labelled {
    padding: 0;
  }

  .discovery-lightbox-body {
    gap: 0.4rem;
    padding: 0 0.5rem 0.75rem;
  }

  .discovery-lightbox-nav {
    width: 38px;
    height: 38px;
  }

  .discovery-lightbox-hint {
    display: none;
  }
}

@keyframes discovery-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

@keyframes discovery-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .discovery-screenshot-card,
  .discovery-screenshot-img,
  .discovery-screenshot-zoom,
  .discovery-screenshot-tooltip,
  .discovery-lightbox,
  .discovery-lightbox-img {
    animation: none;
    transition: none;
  }

  .discovery-screenshot-card:hover,
  .discovery-screenshot-card:focus-within {
    transform: none;
  }

  .discovery-screenshot-card:hover .discovery-screenshot-img.is-loaded {
    transform: none;
  }

  .discovery-screenshot-skeleton-block,
  .discovery-screenshot-skeleton-line {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/wizard.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,yGAAyG;EACzG,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;;EAGE,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,YAAY;AACZ;;;EAGE,uBAAuB;EACvB,sCAAsC;EACtC,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;;EAEE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,8BAA8B,EAAE,uBAAuB;AACzD;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,iFAAiF;EACjF,uBAAuB;EACvB,kBAAkB;EAClB,wDAAwD;EACxD,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA;;iDAEiD;;AAEjD;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uGAAuG;EACvG,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,wBAAwB;EACxB,sCAAsC;EACtC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iFAAiF;EACjF,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,mBAAmB;EACnB,uGAAuG;EACvG,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,yDAA6Q;EAC7Q,4BAA4B;EAC5B,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;;EAEE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,sCAAsC;EACtC,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD,gDAAgD;AAChD;EACE,wBAAwB;EACxB,qCAAqC;EACrC,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,qCAAqC;EACrC,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,sCAAsC;EACtC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,6EAA6E;AAC7E;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,uBAAuB;IACvB,8BAA8B;EAChC;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;iDAEiD;;AAEjD;EACE,kBAAkB;AACpB;;AAEA,eAAe,kBAAkB,EAAE;AACnC,eAAe,gBAAgB,EAAE;AACjC,eAAe,kBAAkB,EAAE;AACnC,eAAe,gBAAgB,EAAE;;AAEjC,eAAe,qBAAqB,EAAE;AACtC,eAAe,mBAAmB,EAAE;AACpC,eAAe,qBAAqB,EAAE;AACtC,eAAe,mBAAmB,EAAE;;AAEpC;;iDAEiD;;AAEjD,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,sCAAsC;EACtC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kEAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;;iDAEiD;;AAEjD,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,sCAAsC;EACtC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;iDAEiD;;AAEjD,8CAA8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,gEAAgE;EAChE,qBAAqB;AACvB;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,yCAAyC;EACzC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;AACA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;AACA;;iDAEiD;;AAEjD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;EACxC,qCAAqC;EACrC,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,4CAA4C;EAC5C,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,+FAA+F;AACjG;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,sEAAsE;EACtE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+GAA+G;AAC/G;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;;;;;;IAME,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* ============================================\n   WIZARD LAYOUT STYLES\n   ============================================ */\n\n.wizard-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-primary);\n  font-family: var(--font-sans, 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  font-feature-settings: \"kern\" 1;\n  font-kerning: normal;\n  color: var(--text-primary);\n}\n\n.wizard-layout *,\n.wizard-layout *::before,\n.wizard-layout *::after {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n.wizard-layout svg {\n  shape-rendering: geometricPrecision;\n}\n\n.wizard-layout.public {\n  background: var(--bg-primary);\n}\n\n.wizard-layout.private {\n  background: var(--bg-primary);\n}\n\n/* Header */\n.wizard-header {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 0.85rem 2rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: none;\n}\n\n.wizard-header-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.wizard-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.wizard-logo img {\n  width: 36px;\n  height: 36px;\n  display: block;\n}\n\n.wizard-logo-text {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--primary-color);\n  letter-spacing: -0.5px;\n}\n\n.wizard-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Buttons */\n.wizard-exit-btn,\n.wizard-save-exit-btn,\n.wizard-back-btn {\n  padding: 0.5rem 1.25rem;\n  border-radius: var(--border-radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.wizard-exit-btn,\n.wizard-save-exit-btn {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.wizard-exit-btn:hover,\n.wizard-save-exit-btn:hover {\n  background: var(--bg-gray-50);\n  border-color: var(--text-secondary);\n}\n\n.wizard-back-btn {\n  background: transparent;\n  color: var(--primary-color);\n  border: 1px solid var(--primary-color);\n}\n\n.wizard-back-btn:hover {\n  background: var(--primary-color);\n  color: var(--white);\n}\n\n/* Main Content */\n.wizard-main {\n  flex: 1;\n  padding: 1rem;\n  overflow-y: auto;\n  max-height: calc(100vh - 80px); /* Account for header */\n}\n\n/* Footer */\n.wizard-footer {\n  background: transparent;\n  border-top: 1px solid color-mix(in srgb, var(--border, #334155) 80%, transparent);\n  padding: 0.85rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted, var(--text-secondary, #94a3b8));\n  font-size: 0.75rem;\n  letter-spacing: 0.01em;\n}\n\n.wizard-footer p {\n  margin: 0;\n  opacity: 0.85;\n}\n\n.wizard-layout.public .wizard-footer,\n.wizard-layout.private .wizard-footer {\n  background: color-mix(in srgb, var(--bg-primary, #07111f) 92%, #000 8%);\n}\n\n/* ============================================\n   WIZARD CONTAINER & CARD\n   ============================================ */\n\n/* ============================================\n   WIZARD HERO TITLE (Step 1)\n   ============================================ */\n\n.wizard-hero-title {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 1.5rem 1rem 0.5rem;\n}\n\n.wizard-eyebrow {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--primary);\n  margin: 0 0 8px;\n}\n\n.wizard-hero-heading {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  font-family: var(--font-sans, Inter, sans-serif);\n}\n\n.wizard-hero-subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n  font-weight: 400;\n  max-width: 560px;\n  margin: 0 auto;\n  line-height: 1.5;\n}\n\n.wizard-progress-steps {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.wizard-progress-step {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 28px;\n  padding: 0 12px;\n  border-radius: 999px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  color: var(--text-muted);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.wizard-progress-step em {\n  font-style: normal;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.wizard-progress-step.is-active {\n  background: var(--primary-muted);\n  border-color: transparent;\n  color: var(--primary);\n}\n\n.wizard-progress-step.is-active em {\n  color: var(--primary);\n}\n\n@media (max-width: 768px) {\n  .wizard-hero-heading {\n    font-size: 24px;\n  }\n\n  .wizard-hero-subtitle {\n    font-size: 13px;\n  }\n\n  .wizard-hero-title {\n    margin-bottom: 1.25rem;\n    padding: 1rem 0.5rem;\n  }\n}\n\n.wizard-container {\n  max-width: 880px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 1.5rem 2rem;\n}\n\n.wizard-card {\n  background: var(--surface);\n  border-radius: 12px;\n  box-shadow: var(--shadow-xs);\n  padding: 1.75rem;\n  margin-bottom: 1.5rem;\n  border: 1px solid var(--border);\n}\n\n.wizard-card-header {\n  margin-bottom: 1.25rem;\n  text-align: left;\n}\n\n.wizard-card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.35rem;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.wizard-card-subtitle {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  max-width: none;\n  margin: 0;\n  font-weight: 400;\n}\n\n.wizard-card-content {\n  /* Content specific styles in step components */\n}\n\n/* ============================================\n   WIZARD ACTIONS (BOTTOM BUTTONS)\n   ============================================ */\n\n.wizard-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid var(--border-light);\n}\n\n.wizard-actions-next-only {\n  justify-content: flex-end;\n}\n\n.wizard-btn {\n  padding: 0.875rem 2rem;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  letter-spacing: -0.2px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.wizard-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.wizard-btn:not(:disabled):hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.wizard-btn:not(:disabled):active {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.wizard-btn-primary {\n  background: var(--primary-color);\n  color: var(--white);\n}\n\n.wizard-btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--box-shadow);\n}\n\n.wizard-btn-secondary {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n}\n\n.wizard-btn-secondary:hover:not(:disabled) {\n  background: var(--bg-gray-50);\n  border-color: var(--text-primary);\n  color: var(--text-primary);\n}\n\n/* Progress Bar for Step 1 */\n.wizard-progress-bar {\n  margin-bottom: 2.5rem;\n}\n\n.wizard-progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.wizard-progress-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.wizard-progress-percentage {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4361ee;\n}\n\n.wizard-progress-track {\n  height: 8px;\n  background: #e9ecef;\n  border-radius: 100px;\n  overflow: hidden;\n}\n\n.wizard-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #4361ee 0%, #5a73f5 100%);\n  border-radius: 100px;\n  transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Intent Grid Layout */\n.intent-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2.5rem;\n}\n\n@media (min-width: 1024px) {\n  .intent-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .intent-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .intent-card {\n    min-height: 200px;\n    padding: 2rem 1.5rem;\n  }\n}\n\n/* ============================================\n   WIZARD PROGRESS BAR\n   ============================================ */\n\n.wizard-progress {\n  margin-bottom: 1rem;\n}\n\n.wizard-progress-bar {\n  width: 100%;\n  height: 8px;\n  background: var(--bg-gray-200);\n  border-radius: var(--border-radius-full);\n  overflow: hidden;\n}\n\n.wizard-progress-fill {\n  height: 100%;\n  background: var(--primary-color);\n  transition: width 0.3s ease;\n  border-radius: var(--border-radius-full);\n}\n\n.wizard-progress-text {\n  display: block;\n  margin-top: 0.5rem;\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n/* ============================================\n   STEPPER (STEP INDICATOR)\n   ============================================ */\n\n.wizard-stepper {\n  margin-bottom: 0.75rem;\n  padding: 0.625rem 1rem;\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.stepper-container {\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 0.25rem 0;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #adb5bd transparent;\n}\n\n.stepper-container::-webkit-scrollbar {\n  height: 6px;\n}\n\n.stepper-container::-webkit-scrollbar-thumb {\n  background-color: #adb5bd;\n  border-radius: 3px;\n}\n\n.stepper-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.stepper-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.375rem;\n  position: relative;\n  flex-shrink: 0;\n  padding: 0.25rem 0.5rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.stepper-step-indicator {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f3f5;\n  border: 2px solid #e9ecef;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.stepper-step.active .stepper-step-indicator {\n  background: #4361ee;\n  border-color: #4361ee;\n  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.12);\n}\n\n.stepper-step.completed .stepper-step-indicator {\n  background: #4285F4;\n  border-color: #4285F4;\n}\n\n.stepper-step.future .stepper-step-indicator {\n  background: #ffffff;\n  border-color: #e9ecef;\n}\n\n.stepper-step-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #868e96;\n}\n\n.stepper-step.active .stepper-step-icon {\n  color: #ffffff;\n}\n\n.stepper-step.completed .stepper-step-icon {\n  color: #ffffff;\n}\n\n.stepper-step-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.125rem;\n}\n\n.stepper-step-number-badge {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: #868e96;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.stepper-step.active .stepper-step-number-badge {\n  color: #4361ee;\n}\n\n.stepper-step.completed .stepper-step-number-badge {\n  color: #4285F4;\n}\n\n.stepper-step-label {\n  font-size: 0.75rem;\n  color: #495057;\n  font-weight: 500;\n  white-space: normal;\n  overflow-wrap: break-word;\n  max-width: 100px;\n  text-align: center;\n  line-height: 1.2;\n}\n\n.stepper-step.active .stepper-step-label {\n  color: #212529;\n  font-weight: 600;\n}\n\n.stepper-step.completed .stepper-step-label {\n  color: #495057;\n}\n\n/* Clickable stepper steps */\n.stepper-step.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.stepper-step.clickable:hover {\n  background: #f8f9fa;\n}\n\n.stepper-step.clickable:hover .stepper-step-indicator {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(67, 97, 238, 0.15);\n}\n\n.stepper-step.clickable:active .stepper-step-indicator {\n  transform: translateY(0);\n}\n\n.stepper-step.clickable:hover .stepper-step-label {\n  color: #4361ee;\n}\n\n.stepper-step.future {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.stepper-step.future .stepper-step-indicator {\n  pointer-events: none;\n}\n\n.stepper-connector {\n  flex: 1 1 0%;\n  min-width: 12px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.stepper-connector-line {\n  width: 100%;\n  height: 2px;\n  background-color: #e2e8f0;;\n  transition: all 0.3s ease;\n}\n\n.stepper-connector.completed {\n  background: #4285F4;\n}\n\n.stepper-connector.completed .stepper-connector-line {\n  background: #4285F4;\n}\n\n/* Compact Stepper (Mobile) */\n.wizard-stepper-compact {\n  padding: 1rem;\n  background: var(--white);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--box-shadow-sm);\n  margin-bottom: 1.5rem;\n}\n\n.stepper-compact-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.stepper-compact-text {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n}\n\n.stepper-compact-percentage {\n  font-size: var(--font-size-sm);\n  color: var(--primary-color);\n  font-weight: var(--font-weight-bold);\n}\n\n.stepper-compact-bar {\n  width: 100%;\n  height: 6px;\n  background: var(--bg-gray-200);\n  border-radius: var(--border-radius-full);\n  overflow: hidden;\n}\n\n.stepper-compact-fill {\n  height: 100%;\n  background: var(--primary-color);\n  transition: width 0.3s ease;\n  border-radius: var(--border-radius-full);\n}\n\n/* ============================================\n   INTENT SELECTION CARDS\n   ============================================ */\n\n.intent-selection-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 0.5rem;\n}\n\n.intent-card {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 14px 16px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n  text-align: left;\n  min-height: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 14px;\n  position: relative;\n  box-shadow: none;\n}\n\n.intent-card:hover {\n  border-color: var(--border-strong);\n  box-shadow: var(--shadow-xs);\n  transform: none;\n  background: var(--surface-hover);\n}\n\n.intent-card.disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.intent-card.disabled:hover {\n  border-color: var(--border);\n  box-shadow: none;\n  transform: none;\n  background: var(--surface);\n}\n\n.intent-card-badge {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  background: var(--warning-muted);\n  color: var(--warning);\n  padding: 0.25rem 0.6rem;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  box-shadow: none;\n}\n\n.intent-card.selected {\n  border-color: var(--primary);\n  background: var(--primary-subtle);\n  box-shadow: none;\n  transform: none;\n}\n\n.intent-card.selected::before,\n.intent-card.selected::after {\n  display: none;\n}\n\n.intent-card-icon {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  background: var(--primary-muted);\n  border-radius: 8px;\n  color: var(--primary);\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.intent-card:hover .intent-card-icon {\n  background: var(--primary-muted);\n  color: var(--primary);\n  transform: none;\n}\n\n.intent-card.selected .intent-card-icon {\n  background: var(--primary);\n  color: #fff;\n  transform: none;\n  box-shadow: none;\n}\n\n.intent-card-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.intent-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n  letter-spacing: -0.01em;\n  line-height: 1.35;\n  font-family: var(--font-sans, Inter, sans-serif);\n}\n\n.intent-card-description {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.45;\n  font-weight: 400;\n  max-width: none;\n  margin: 0;\n  font-family: var(--font-sans, Inter, sans-serif);\n}\n\n.intent-card-arrow {\n  color: var(--text-muted);\n  font-size: 16px;\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.intent-card.selected .intent-card-arrow {\n  color: var(--primary);\n}\n\n/* ============================================\n   FORM ELEMENTS\n   ============================================ */\n\n.wizard-form-group {\n  margin-bottom: 2rem;\n  display: block;\n  width: 100%;\n}\n\n/* Two-column Form Grid - Must come after wizard-form-group */\n.wizard-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 1.5rem;\n  row-gap: 0;\n  margin-bottom: 2rem;\n  width: 100%;\n}\n\n.wizard-form-row > .wizard-form-group {\n  margin-bottom: 0;\n  width: 100%;\n}\n\n.wizard-form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n  margin-bottom: 0.625rem;\n  letter-spacing: -0.2px;\n}\n\n.wizard-form-label .required {\n  color: #dc3545;\n  margin-left: 0.25rem;\n  font-weight: 700;\n}\n\n.wizard-form-label-row {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  margin-bottom: 0.625rem;\n}\n\n.wizard-form-label-row .wizard-form-label {\n  display: inline;\n  margin-bottom: 0;\n  line-height: 1.25;\n}\n\n.wizard-help-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgba(33, 150, 243, 0.12);\n  color: #1976d2;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: help;\n  position: relative;\n  top: 0;\n  user-select: none;\n}\n\n.wizard-help-icon:focus {\n  outline: 2px solid rgba(25, 118, 210, 0.35);\n  outline-offset: 2px;\n}\n\n.wizard-help-tooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #212529;\n  color: #fff;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 400;\n  line-height: 1.4;\n  white-space: normal;\n  width: max-content;\n  max-width: 260px;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n  z-index: 20;\n}\n\n.wizard-help-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #212529;\n}\n\n.wizard-help-icon:hover .wizard-help-tooltip,\n.wizard-help-icon:focus .wizard-help-tooltip,\n.wizard-help-icon:focus-within .wizard-help-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n.wizard-form-input,\n.wizard-form-select,\n.wizard-form-textarea {\n  width: 100%;\n  padding: 0.875rem 1.125rem;\n  border: 2px solid #dee2e6;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 400;\n  color: #212529;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  background: #ffffff;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.wizard-form-input::placeholder,\n.wizard-form-select::placeholder,\n.wizard-form-textarea::placeholder {\n  color: #adb5bd;\n  font-weight: 400;\n}\n\n.wizard-form-input:hover,\n.wizard-form-select:hover,\n.wizard-form-textarea:hover {\n  border-color: #adb5bd;\n}\n\n.wizard-form-input:focus,\n.wizard-form-select:focus,\n.wizard-form-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.08);\n  background: #ffffff;\n}\n\n.wizard-form-select {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%23495057' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1.125rem center;\n  padding-right: 3rem;\n  appearance: none;\n  cursor: pointer;\n}\n\n.wizard-form-textarea {\n  min-height: 120px;\n  resize: vertical;\n  line-height: 1.6;\n}\n\n.wizard-form-help {\n  font-size: 13px;\n  color: #6c757d;\n  margin-top: 0.5rem;\n  line-height: 1.4;\n  font-weight: 400;\n}\n\n.wizard-form-error {\n  font-size: 13px;\n  color: #dc3545;\n  margin-top: 0.5rem;\n  font-weight: 500;\n}\n\n/* Error state for form inputs */\n.wizard-form-input.error,\n.wizard-form-select.error,\n.wizard-form-textarea.error {\n  border-color: #dc3545;\n  background: #fff8f9;\n}\n\n.wizard-form-input.error:focus,\n.wizard-form-select.error:focus,\n.wizard-form-textarea.error:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.08);\n}\n\n/* Checkbox/Radio - Professional */\n.wizard-form-checkbox,\n.wizard-form-radio {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.875rem;\n}\n\n.wizard-form-checkbox input,\n.wizard-form-radio input {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  margin-top: 2px;\n  accent-color: var(--primary-color);\n}\n\n.wizard-form-checkbox label,\n.wizard-form-radio label {\n  font-size: 15px;\n  color: #212529;\n  cursor: pointer;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n/* File Upload */\n.wizard-file-upload {\n  border: 2px dashed var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: 2rem;\n  text-align: center;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.wizard-file-upload:hover {\n  border-color: var(--primary-color);\n  background: rgba(67, 97, 238, 0.02);\n}\n\n.wizard-file-upload-icon {\n  font-size: 3rem;\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n}\n\n.wizard-file-upload-text {\n  font-size: var(--font-size-md);\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.wizard-file-upload-hint {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n/* ============================================\n   STEP 4 PATH SELECTOR & CARDS (New)\n   ============================================ */\n\n/* Path Selector Cards (Connect/Upload/Create) */\n.wizard-path-card {\n  background: var(--white);\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  padding: 1.5rem 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-path-card:hover {\n  border-color: var(--primary-color);\n  box-shadow: var(--box-shadow-md);\n  transform: translateY(-2px);\n}\n\n.wizard-path-card.active {\n  border-color: var(--primary-color);\n  background: rgba(67, 97, 238, 0.05);\n  box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.1);\n}\n\n.wizard-path-icon {\n  font-size: 2.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.wizard-path-title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.wizard-path-description {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.wizard-path-content {\n  margin-top: 1.5rem;\n}\n\n/* Template Selection Cards */\n.wizard-template-card {\n  background: var(--white);\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius-md);\n  padding: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.wizard-template-card:hover {\n  border-color: var(--primary-color);\n  box-shadow: var(--box-shadow);\n  transform: translateY(-2px);\n}\n\n.wizard-template-card.active {\n  border-color: var(--primary-color);\n  background: rgba(67, 97, 238, 0.05);\n  box-shadow: 0 0 0 3px rgba(67, 97, 238, 0.1);\n}\n\n/* Small Button Variant */\n.wizard-btn-sm {\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid var(--border-color);\n  background: var(--white);\n  color: var(--text-secondary);\n}\n\n.wizard-btn-sm.wizard-btn-primary {\n  background: var(--primary-color);\n  color: var(--white);\n  border-color: var(--primary-color);\n}\n\n.wizard-btn-sm.wizard-btn-secondary {\n  background: transparent;\n  color: var(--text-secondary);\n  border-color: var(--border-color);\n}\n\n.wizard-btn-sm:hover:not(:disabled) {\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.wizard-btn-sm.wizard-btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  color: var(--white);\n}\n\n/* ============================================\n   LOADING & PROGRESS\n   ============================================ */\n\n.wizard-loading {\n  text-align: center;\n  padding: 3rem;\n}\n\n.wizard-loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid var(--bg-gray-200);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Lucide Icon Spinner */\n.spinner {\n  animation: spin 1s linear infinite;\n  display: inline-block;\n}\n\n/* Separate from .spinner, which other stylesheets give width/border/margin */\n.icon-spin {\n  animation: spin 1s linear infinite;\n  display: block;\n}\n\n/* ============================================\n   MODE SELECTION CARDS (Step 5)\n   ============================================ */\n\n.wizard-mode-card {\n  padding: 2rem 1.5rem;\n  background-color: var(--card-bg);\n  border: 2px solid var(--border-color);\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.wizard-mode-card:hover {\n  border-color: var(--primary-color);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.wizard-mode-card.selected {\n  border-color: var(--primary-color);\n  background-color: var(--primary-color-light);\n  box-shadow: 0 4px 16px rgba(79, 70, 229, 0.2);\n}\n\n.wizard-mode-card.recommended {\n  border-color: var(--success-color);\n}\n\n.wizard-recommended-badge {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  padding: 0.375rem 0.75rem;\n  background-color: var(--success-color);\n  color: #fff;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* ============================================\n   WARNING MODAL (Step 5)\n   ============================================ */\n\n.wizard-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease;\n}\n\n.wizard-modal {\n  background-color: var(--card-bg);\n  border-radius: 16px;\n  padding: 2rem;\n  max-width: 560px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  animation: slideUp 0.3s ease;\n  position: relative;\n  z-index: 10001;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.wizard-loading-text {\n  font-size: var(--font-size-lg);\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.wizard-loading-subtext {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n.spinner-small {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--white);\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n/* Progress Stages */\n.wizard-progress-stages {\n  margin-top: 2rem;\n}\n\n.wizard-progress-stage {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-gray-50);\n  border-radius: var(--border-radius-md);\n  margin-bottom: 0.75rem;\n}\n\n.wizard-progress-stage.active {\n  background: rgba(67, 97, 238, 0.1);\n}\n\n.wizard-progress-stage.completed {\n  background: rgba(76, 201, 240, 0.1);\n}\n\n.wizard-progress-stage-icon {\n  font-size: 1.5rem;\n}\n\n.wizard-progress-stage-text {\n  flex: 1;\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-primary);\n}\n\n/* Logs Display */\n.wizard-logs {\n  background: #1e1e1e;\n  border-radius: var(--border-radius-md);\n  padding: 1.5rem;\n  max-height: 400px;\n  overflow-y: auto;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: var(--font-size-sm);\n}\n\n.wizard-log-line {\n  color: #d4d4d4;\n  margin-bottom: 0.5rem;\n  line-height: 1.6;\n}\n\n.wizard-log-line.info {\n  color: #4fc1ff;\n}\n\n.wizard-log-line.success {\n  color: #4cc9f0;\n}\n\n.wizard-log-line.error {\n  color: #f72585;\n}\n\n.wizard-log-line.warning {\n  color: #f8961e;\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n\n@media (max-width: 768px) {\n  .wizard-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .wizard-main {\n    padding: 0.75rem;\n    max-height: calc(100vh - 70px);\n  }\n\n  .wizard-container {\n    padding: 0 1rem;\n  }\n\n  .wizard-card {\n    padding: 1rem;\n  }\n\n  .wizard-card-title {\n    font-size: var(--font-size-xl);\n  }\n\n  .wizard-stepper {\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .stepper-step {\n    padding: 0.25rem 0.375rem;\n  }\n\n  .stepper-step-indicator {\n    width: 28px;\n    height: 28px;\n  }\n\n  .stepper-step-label {\n    font-size: 0.6875rem;\n    max-width: 80px;\n  }\n\n  .stepper-connector {\n    min-width: 8px;\n  }\n\n  .intent-selection-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .intent-card {\n    min-height: 140px;\n    padding: 1rem;\n  }\n\n  .wizard-actions {\n    flex-direction: column-reverse;\n    margin-top: 1rem;\n    padding-top: 1rem;\n  }\n\n  .wizard-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .stepper-container {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    padding-bottom: 0.5rem;\n    scroll-snap-type: x proximity;\n  }\n\n  .stepper-step {\n    scroll-snap-align: center;\n  }\n\n  .wizard-header-actions {\n    gap: 0.5rem;\n  }\n\n  .wizard-exit-btn,\n  .wizard-save-exit-btn,\n  .wizard-back-btn {\n    padding: 0.5rem 0.75rem;\n    font-size: var(--font-size-xs);\n  }\n}\n\n/* ============================================\n   AUTH TABS (Login/Signup Switcher)\n   ============================================ */\n\n.wizard-auth-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  border-bottom: 2px solid var(--border-color);\n}\n\n.wizard-auth-tab {\n  flex: 1;\n  padding: 0.875rem 1rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.wizard-auth-tab:hover {\n  color: var(--text-primary);\n  background: rgba(67, 97, 238, 0.02);\n}\n\n.wizard-auth-tab.active {\n  color: var(--primary-color);\n  border-bottom-color: var(--primary-color);\n  background: rgba(67, 97, 238, 0.05);\n}\n\n.wizard-auth-content {\n  min-height: 420px;\n  max-height: 500px;\n  overflow-y: auto;\n  padding: 0.5rem 0;\n}\n\n.wizard-auth-progress {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-light);\n}\n\n/* ============================================\n   UTILITY CLASSES\n   ============================================ */\n\n.wizard-text-center {\n  text-align: center;\n}\n\n.wizard-mt-1 { margin-top: 0.5rem; }\n.wizard-mt-2 { margin-top: 1rem; }\n.wizard-mt-3 { margin-top: 1.5rem; }\n.wizard-mt-4 { margin-top: 2rem; }\n\n.wizard-mb-1 { margin-bottom: 0.5rem; }\n.wizard-mb-2 { margin-bottom: 1rem; }\n.wizard-mb-3 { margin-bottom: 1.5rem; }\n.wizard-mb-4 { margin-bottom: 2rem; }\n\n/* ============================================\n   STEP 5: AI PREVIEW & EDITING STYLES\n   ============================================ */\n\n/* Statistics Dashboard */\n.ai-preview-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.ai-preview-stat-card {\n  background: white;\n  border: 2px solid var(--primary-color);\n  border-radius: var(--border-radius-md);\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: var(--box-shadow-sm);\n  transition: all 0.3s ease;\n}\n\n.ai-preview-stat-card:hover {\n  box-shadow: var(--box-shadow-md);\n  border-color: var(--primary-dark);\n}\n\n.ai-preview-stat-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  flex-shrink: 0;\n  background: rgba(67, 97, 238, 0.1);\n  border-radius: var(--border-radius-md);\n  color: var(--primary-color);\n}\n\n.ai-preview-stat-icon svg {\n  display: block;\n}\n\n.ai-preview-stat-content {\n  flex: 1;\n}\n\n.ai-preview-stat-value {\n  font-size: 2rem;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: 0.25rem;\n  color: var(--primary-color);\n}\n\n.ai-preview-stat-label {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n/* AI Insights Panel */\n.ai-preview-insights {\n  background: #e3f2fd;\n  border: 1px solid #90caf9;\n  border-left: 4px solid var(--primary-color);\n  border-radius: var(--border-radius-md);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.ai-preview-insights-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.ai-preview-insights-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--primary-color);\n}\n\n.ai-preview-insights-icon {\n  font-size: 1.5rem;\n}\n\n.ai-preview-insights-close {\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  font-size: 1.5rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.ai-preview-insights-close:hover {\n  background: rgba(67, 97, 238, 0.1);\n  color: var(--primary-color);\n}\n\n.ai-preview-insights-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.ai-preview-insight-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.ai-preview-insight-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  font-weight: bold;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.ai-preview-insight-badge.success {\n  background: rgba(76, 175, 80, 0.9);\n}\n\n.ai-preview-insight-badge.warning {\n  background: rgba(255, 152, 0, 0.9);\n}\n\n.ai-preview-insight-badge.info {\n  background: rgba(33, 150, 243, 0.9);\n}\n\n/* Action Toolbar */\n.ai-preview-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: var(--bg-light);\n  border-radius: var(--border-radius-md);\n  border: 1px solid var(--border-color);\n}\n\n.ai-preview-toolbar-left,\n.ai-preview-toolbar-right {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.ai-preview-toolbar-btn {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--border-color);\n  background: white;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ai-preview-toolbar-btn:hover {\n  background: var(--bg-light);\n  border-color: var(--primary-color);\n}\n\n.ai-preview-toolbar-btn.primary {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n.ai-preview-toolbar-btn.primary:hover {\n  background: var(--primary-dark);\n  border-color: var(--primary-dark);\n}\n\n.ai-preview-toolbar-btn.danger {\n  color: var(--danger-color);\n  border-color: var(--danger-color);\n}\n\n.ai-preview-toolbar-btn.danger:hover {\n  background: var(--danger-color);\n  color: white;\n}\n\n.ai-preview-filter {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--border-color);\n  background: white;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n}\n\n.ai-preview-filter:hover,\n.ai-preview-filter:focus {\n  border-color: var(--primary-color);\n  outline: none;\n}\n\n.ai-preview-view-toggle {\n  display: flex;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  overflow: hidden;\n}\n\n.ai-preview-view-btn {\n  background: white;\n  border: none;\n  padding: 0.5rem 0.75rem;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-right: 1px solid var(--border-color);\n}\n\n.ai-preview-view-btn:last-child {\n  border-right: none;\n}\n\n.ai-preview-view-btn.active {\n  background: var(--primary-color);\n  color: white;\n}\n\n.ai-preview-view-btn:hover:not(.active) {\n  background: var(--bg-light);\n}\n\n/* Cases Container */\n.ai-preview-cases-container {\n  margin-bottom: 2rem;\n}\n\n.ai-preview-select-all {\n  padding: 0.75rem 1rem;\n  background: var(--bg-light);\n  border: 1px solid var(--border-color);\n  border-bottom: none;\n  border-radius: var(--border-radius-md) var(--border-radius-md) 0 0;\n}\n\n.ai-preview-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ai-preview-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.ai-preview-cases {\n  border: 1px solid var(--border-color);\n  border-radius: 0 0 var(--border-radius-md) var(--border-radius-md);\n  overflow: hidden;\n}\n\n.ai-preview-cases.grid-view {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--bg-light);\n}\n\n.ai-preview-cases.list-view {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Test Case Card */\n.ai-preview-case {\n  background: white;\n  border-bottom: 1px solid var(--border-color);\n  transition: all 0.3s ease;\n}\n\n.ai-preview-cases.grid-view .ai-preview-case {\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-md);\n  overflow: hidden;\n}\n\n.ai-preview-cases.list-view .ai-preview-case:last-child {\n  border-bottom: none;\n}\n\n.ai-preview-case.selected {\n  background: #f0f4ff;\n  border-color: var(--primary-color);\n}\n\n.ai-preview-case.expanded {\n  box-shadow: var(--box-shadow-md);\n}\n\n.ai-preview-case-header {\n  display: flex;\n  align-items: start;\n  gap: 1rem;\n  padding: 1rem;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.ai-preview-case-header:hover {\n  background: var(--bg-lighter);\n}\n\n.ai-preview-case-header-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ai-preview-case-header-left input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.ai-preview-case-number {\n  font-weight: 600;\n  color: var(--text-secondary);\n  min-width: 30px;\n}\n\n.ai-preview-case-header-center {\n  flex: 1;\n  min-width: 0;\n}\n\n.ai-preview-case-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem 0;\n  cursor: text;\n}\n\n.ai-preview-case-name:hover {\n  color: var(--primary-color);\n}\n\n.ai-preview-case-name-input {\n  width: 100%;\n  padding: 0.25rem 0.5rem;\n  border: 2px solid var(--primary-color);\n  border-radius: var(--border-radius-sm);\n  font-size: 1rem;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.ai-preview-case-meta {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.ai-preview-case-steps {\n  font-weight: 500;\n}\n\n.ai-preview-case-dot {\n  opacity: 0.5;\n}\n\n.ai-preview-priority-select {\n  padding: 0.25rem 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  background: white;\n}\n\n.ai-preview-priority-select.priority-high {\n  color: var(--danger-color);\n  border-color: var(--danger-color);\n  background: rgba(244, 67, 54, 0.1);\n}\n\n.ai-preview-priority-select.priority-medium {\n  color: var(--warning-color);\n  border-color: var(--warning-color);\n  background: rgba(255, 152, 0, 0.1);\n}\n\n.ai-preview-priority-select.priority-low {\n  color: var(--success-color);\n  border-color: var(--success-color);\n  background: rgba(76, 175, 80, 0.1);\n}\n\n.ai-preview-case-header-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.ai-preview-case-tags {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.ai-preview-tag {\n  padding: 0.25rem 0.75rem;\n  background: rgba(67, 97, 238, 0.1);\n  color: var(--primary-color);\n  border-radius: var(--border-radius-full);\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.ai-preview-case-actions {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.ai-preview-action-btn {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  width: 32px;\n  height: 32px;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.ai-preview-action-btn:hover {\n  background: var(--bg-light);\n  border-color: var(--primary-color);\n}\n\n/* Case Details (Expanded) */\n.ai-preview-case-details {\n  padding: 0 1rem 1rem 4rem;\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-lighter);\n}\n\n.ai-preview-steps-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n}\n\n.ai-preview-steps-header h5 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.ai-preview-add-step-btn {\n  padding: 0.375rem 0.75rem;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.ai-preview-add-step-btn:hover {\n  background: var(--primary-dark);\n}\n\n.ai-preview-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.ai-preview-step {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-md);\n}\n\n.ai-preview-step-number {\n  min-width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary-color);\n  color: white;\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 0.875rem;\n  flex-shrink: 0;\n}\n\n.ai-preview-step-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.ai-preview-step-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.ai-preview-step-action,\n.ai-preview-step-expected {\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.ai-preview-step-action strong,\n.ai-preview-step-expected strong {\n  color: var(--text-secondary);\n  font-weight: 600;\n  margin-right: 0.5rem;\n}\n\n.ai-preview-step-field {\n  margin-bottom: 0.75rem;\n}\n\n.ai-preview-step-field label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.ai-preview-step-field input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.9rem;\n  transition: border-color 0.3s ease;\n}\n\n.ai-preview-step-field input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.ai-preview-step-save {\n  padding: 0.5rem 1rem;\n  background: var(--success-color);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.ai-preview-step-save:hover {\n  background: #388e3c;\n}\n\n.ai-preview-step-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.ai-preview-step-action-btn {\n  padding: 0.375rem 0.75rem;\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.875rem;\n}\n\n.ai-preview-step-action-btn:hover {\n  background: var(--bg-light);\n  border-color: var(--primary-color);\n}\n\n.ai-preview-step-action-btn.danger:hover {\n  background: var(--danger-color);\n  color: white;\n  border-color: var(--danger-color);\n}\n\n/* Empty State */\n.ai-preview-empty {\n  padding: 3rem;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.ai-preview-empty-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .ai-preview-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .ai-preview-toolbar {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .ai-preview-toolbar-left,\n  .ai-preview-toolbar-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .ai-preview-cases.grid-view {\n    grid-template-columns: 1fr;\n  }\n\n  .ai-preview-case-header {\n    flex-wrap: wrap;\n  }\n\n  .ai-preview-case-details {\n    padding: 0 0.5rem 1rem 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .ai-preview-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .ai-preview-case-header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n/* ============================================\n   REQUIREMENT TRACEABILITY STYLES\n   ============================================ */\n\n/* Traceability Toggle Button */\n.ai-preview-traceability-toggle {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.ai-preview-traceability-btn {\n  padding: 0.75rem 1.5rem;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: var(--box-shadow-sm);\n}\n\n.ai-preview-traceability-btn:hover {\n  background: var(--primary-dark);\n  box-shadow: var(--box-shadow-md);\n}\n\n.ai-preview-traceability-btn.active {\n  background: var(--primary-dark);\n}\n\n.ai-preview-traceability-btn .ai-preview-badge {\n  background: rgba(255, 255, 255, 0.25);\n  padding: 0.25rem 0.5rem;\n  border-radius: var(--border-radius-full);\n  font-size: 0.75rem;\n  margin-left: 0.25rem;\n}\n\n/* Traceability Panel */\n.ai-preview-traceability-panel {\n  background: #f0f4ff;\n  border: 1px solid #d0ddff;\n  border-left: 4px solid var(--primary-color);\n  border-radius: var(--border-radius-lg);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.ai-preview-traceability-header {\n  margin-bottom: 1.5rem;\n}\n\n.ai-preview-traceability-header h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem 0;\n}\n\n.ai-preview-traceability-subtitle {\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.ai-preview-requirements-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.ai-preview-requirement-card {\n  background: white;\n  border-radius: var(--border-radius-md);\n  padding: 1rem;\n  box-shadow: var(--box-shadow-sm);\n  transition: all 0.3s ease;\n}\n\n.ai-preview-requirement-card:hover {\n  box-shadow: var(--box-shadow-md);\n  transform: translateX(4px);\n}\n\n.ai-preview-requirement-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.ai-preview-requirement-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.ai-preview-requirement-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: var(--border-radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.ai-preview-requirement-badge.jira_epic,\n.ai-preview-requirement-badge.jira_story {\n  background: #0052cc;\n  color: white;\n}\n\n.ai-preview-requirement-badge.uploaded_doc {\n  background: #ff9800;\n  color: white;\n}\n\n.ai-preview-requirement-badge.requirements_lite {\n  background: #4caf50;\n  color: white;\n}\n\n.ai-preview-requirement-key {\n  font-weight: 600;\n  color: var(--primary-color);\n  font-size: 0.9rem;\n}\n\n.ai-preview-requirement-title {\n  color: var(--text-primary);\n  font-size: 0.9rem;\n}\n\n.ai-preview-requirement-coverage {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 200px;\n}\n\n.ai-preview-requirement-coverage-bar {\n  flex: 1;\n  height: 8px;\n  background: #e0e0e0;\n  border-radius: var(--border-radius-full);\n  overflow: hidden;\n}\n\n.ai-preview-requirement-coverage-fill {\n  height: 100%;\n  background: var(--primary-color);\n  transition: width 0.5s ease;\n}\n\n.ai-preview-requirement-coverage-text {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n/* Requirement Badge on Test Case */\n.ai-preview-req-badge {\n  padding: 0.25rem 0.5rem;\n  background: var(--primary-color);\n  color: white;\n  border-radius: var(--border-radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* Mapping Panel */\n.ai-preview-mapping-panel {\n  padding: 1rem;\n  background: #f8f9fa;\n  border-top: 2px solid var(--primary-color);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.ai-preview-mapping-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.ai-preview-mapping-header h5 {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.ai-preview-mapping-close {\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.ai-preview-mapping-close:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--text-primary);\n}\n\n.ai-preview-mapping-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.ai-preview-mapping-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: white;\n  border: 2px solid var(--border-color);\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.ai-preview-mapping-item:hover {\n  border-color: var(--primary-color);\n  background: #f0f4ff;\n}\n\n.ai-preview-mapping-item.mapped {\n  border-color: var(--success-color);\n  background: #f1f8f4;\n}\n\n.ai-preview-mapping-item input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.ai-preview-mapping-req-info {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.ai-preview-mapping-badge {\n  padding: 0.2rem 0.6rem;\n  border-radius: var(--border-radius-full);\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.ai-preview-mapping-badge.jira_epic,\n.ai-preview-mapping-badge.jira_story {\n  background: #0052cc;\n  color: white;\n}\n\n.ai-preview-mapping-badge.uploaded_doc {\n  background: #ff9800;\n  color: white;\n}\n\n.ai-preview-mapping-badge.requirements_lite {\n  background: #4caf50;\n  color: white;\n}\n\n.ai-preview-mapping-key {\n  font-weight: 600;\n  color: var(--primary-color);\n  font-size: 0.85rem;\n}\n\n.ai-preview-mapping-title {\n  color: var(--text-primary);\n  font-size: 0.85rem;\n}\n\n.ai-preview-mapping-check {\n  color: var(--success-color);\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n/* Linked Requirements Display */\n.ai-preview-linked-requirements {\n  padding: 1rem;\n  background: #f0f4ff;\n  border-left: 4px solid var(--primary-color);\n  border-radius: var(--border-radius-sm);\n  margin-bottom: 1rem;\n}\n\n.ai-preview-linked-requirements h5 {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 0.75rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.ai-preview-linked-requirements h5::before {\n  content: \"🔗\";\n  font-size: 1rem;\n}\n\n.ai-preview-linked-req-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.ai-preview-linked-req {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  background: white;\n  border-radius: var(--border-radius-sm);\n  flex-wrap: wrap;\n}\n\n.ai-preview-linked-req-badge {\n  padding: 0.2rem 0.6rem;\n  border-radius: var(--border-radius-full);\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.ai-preview-linked-req-badge.jira_epic,\n.ai-preview-linked-req-badge.jira_story {\n  background: #0052cc;\n  color: white;\n}\n\n.ai-preview-linked-req-badge.uploaded_doc {\n  background: #ff9800;\n  color: white;\n}\n\n.ai-preview-linked-req-badge.requirements_lite {\n  background: #4caf50;\n  color: white;\n}\n\n.ai-preview-linked-req-key {\n  font-weight: 600;\n  color: var(--primary-color);\n  font-size: 0.85rem;\n}\n\n.ai-preview-linked-req-title {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .ai-preview-requirement-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .ai-preview-requirement-coverage {\n    width: 100%;\n  }\n\n  .ai-preview-mapping-req-info {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n/* ============================================\n   WORKSPACE FORM - NEW STYLES\n   ============================================ */\n\n/* Two-column grid layout for workspace form */\n.wizard-workspace-form {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.wizard-workspace-form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.wizard-workspace-form-group label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.wizard-workspace-form-group label .required {\n  color: #ef4444;\n  margin-left: 0.25rem;\n  font-weight: 700;\n}\n\n.wizard-workspace-form-group input,\n.wizard-workspace-form-group select {\n  width: 100%;\n  padding: 0.5rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.5rem;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  color: #111827;\n  transition: all 0.2s ease;\n  background: #ffffff;\n  font-family: inherit;\n}\n\n.wizard-workspace-form-group input:disabled,\n.wizard-workspace-form-group select:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n  cursor: not-allowed;\n  border-color: #e5e7eb;\n}\n\n.wizard-workspace-form-group input:focus,\n.wizard-workspace-form-group select:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1), 0 0 0 1px #3b82f6;\n  border-color: #3b82f6;\n}\n\n/* Ensure select option styling doesn't affect border */\n.wizard-workspace-form-group select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 1rem;\n  padding-right: 2.5rem;\n}\n\n.wizard-workspace-form-group p {\n  font-size: 0.75rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n}\n\n.wizard-workspace-form-group p.error {\n  color: #ef4444;\n}\n\n/* Edit mode header with edit icon */\n.wizard-workspace-edit-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.wizard-workspace-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #2563eb;\n  background: transparent;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.wizard-workspace-edit-btn:hover {\n  background-color: #eff6ff;\n  color: #1d4ed8;\n}\n\n.wizard-workspace-edit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Update/Cancel button group in edit header */\n.wizard-workspace-edit-actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.wizard-workspace-edit-actions button {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-workspace-edit-actions button.primary {\n  color: white;\n  background-color: #2563eb;\n}\n\n.wizard-workspace-edit-actions button.primary:hover:not(:disabled) {\n  background-color: #1d4ed8;\n}\n\n.wizard-workspace-edit-actions button.primary:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.wizard-workspace-edit-actions button.secondary {\n  color: #374151;\n  background: transparent;\n  border: 1px solid #d1d5db;\n}\n\n.wizard-workspace-edit-actions button.secondary:hover:not(:disabled) {\n  background-color: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.wizard-workspace-edit-actions button.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Action buttons for workspace */\n.wizard-workspace-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.wizard-workspace-actions button {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-workspace-actions button.back {\n  color: #374151;\n  border: 1px solid #d1d5db;\n  background: white;\n}\n\n.wizard-workspace-actions button.back:hover {\n  background-color: #f3f4f6;\n}\n\n.wizard-workspace-actions button.back:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wizard-workspace-actions button.primary {\n  color: white;\n  background-color: #2563eb;\n  margin-left: auto;\n}\n\n.wizard-workspace-actions button.primary:hover {\n  background-color: #1d4ed8;\n}\n\n.wizard-workspace-actions button.primary:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.wizard-workspace-actions button.secondary {\n  color: #374151;\n  border: 1px solid #d1d5db;\n  background: white;\n}\n\n.wizard-workspace-actions button.secondary:hover {\n  background-color: #f3f4f6;\n}\n\n.wizard-workspace-actions button.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Responsive: Stack on mobile */\n@media (max-width: 768px) {\n  .wizard-workspace-form {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .wizard-workspace-actions {\n    flex-direction: column-reverse;\n  }\n\n  .wizard-workspace-actions button.primary {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .wizard-workspace-actions button.back {\n    width: 100%;\n  }\n}\n/* Project Edit Styles - Similar to Workspace */\n.wizard-project-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.wizard-project-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #2563eb;\n  background: transparent;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.wizard-project-edit-btn:hover {\n  background-color: #eff6ff;\n  color: #1d4ed8;\n}\n\n.wizard-project-edit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Update/Cancel button group in project edit header */\n.wizard-project-edit-actions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.wizard-project-edit-actions button {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-project-edit-actions button.primary {\n  color: white;\n  background-color: #2563eb;\n}\n\n.wizard-project-edit-actions button.primary:hover:not(:disabled) {\n  background-color: #1d4ed8;\n}\n\n.wizard-project-edit-actions button.primary:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.wizard-project-edit-actions button.secondary {\n  color: #374151;\n  background: transparent;\n  border: 1px solid #d1d5db;\n}\n\n.wizard-project-edit-actions button.secondary:hover:not(:disabled) {\n  background-color: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.wizard-project-edit-actions button.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Action buttons for project */\n.wizard-project-actions {\n  display: flex;\n  gap: 0.75rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.wizard-project-actions button {\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem; \n  font-weight: 500;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.wizard-project-actions button.back {\n  color: #374151;\n  border: 1px solid #d1d5db;\n  background: white;\n}\n\n.wizard-project-actions button.back:hover {\n  background-color: #f3f4f6;\n}\n\n.wizard-project-actions button.back:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wizard-project-actions button.primary {\n  color: white;\n  background-color: #2563eb;\n  margin-left: auto;\n}\n\n.wizard-project-actions button.primary:hover {\n  background-color: #1d4ed8;\n}\n\n.wizard-project-actions button.primary:disabled {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.wizard-project-actions button.secondary {\n  color: #374151;\n  border: 1px solid #d1d5db;\n  background: white;\n}\n\n.wizard-project-actions button.secondary:hover {\n  background-color: #f3f4f6;\n}\n\n.wizard-project-actions button.secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Responsive: Stack on mobile */\n@media (max-width: 768px) {\n  .wizard-project-section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .wizard-project-actions {\n    flex-direction: column-reverse;\n  }\n\n  .wizard-project-actions button.primary {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .wizard-project-actions button.back {\n    width: 100%;\n  }\n}\n/* ============================================\n   DISCOVERY SCREENSHOT GALLERY (Step 10C)\n   ============================================ */\n\n.discovery-screenshot-gallery {\n  margin-bottom: 2rem;\n}\n\n.discovery-screenshot-header {\n  margin-bottom: 1rem;\n}\n\n.discovery-screenshot-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.discovery-screenshot-count {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 0.25rem;\n  padding: 0.1rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(67, 97, 238, 0.1);\n  color: var(--primary-color);\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.discovery-screenshot-subtitle {\n  margin: 0.35rem 0 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.discovery-screenshot-panel {\n  padding: 1.5rem;\n  background-color: var(--card-bg, var(--white));\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n\n/* Grid: four cards per row on desktop, fewer on smaller screens */\n.discovery-screenshot-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n@media (max-width: 1024px) {\n  .discovery-screenshot-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .discovery-screenshot-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.75rem;\n  }\n\n  .discovery-screenshot-panel {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .discovery-screenshot-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* Card */\n.discovery-screenshot-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  background: var(--card-bg, var(--white));\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.discovery-screenshot-card:hover,\n.discovery-screenshot-card:focus-within {\n  z-index: 10;\n  transform: translateY(-2px);\n  border-color: rgba(67, 97, 238, 0.45);\n  box-shadow: var(--box-shadow-md);\n}\n\n.discovery-screenshot-card.is-skeleton {\n  pointer-events: none;\n}\n\n.discovery-screenshot-thumb {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  padding: 0;\n  border: none;\n  border-bottom: 1px solid var(--border-light);\n  border-radius: 9px 9px 0 0;\n  background: var(--bg-gray-100);\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.discovery-screenshot-thumb:focus-visible {\n  outline: none;\n  box-shadow: inset 0 0 0 2px var(--primary-color);\n}\n\n.discovery-screenshot-img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: top center;\n  opacity: 0;\n  transition: opacity 0.3s ease, transform 0.35s ease;\n}\n\n.discovery-screenshot-img.is-loaded {\n  opacity: 1;\n}\n\n.discovery-screenshot-card:hover .discovery-screenshot-img.is-loaded {\n  transform: scale(1.03);\n}\n\n.discovery-screenshot-skeleton-block,\n.discovery-screenshot-skeleton-line {\n  display: block;\n  background: linear-gradient(90deg, #eef1f5 25%, #f8f9fb 50%, #eef1f5 75%);\n  background-size: 200% 100%;\n  animation: discovery-shimmer 1.4s ease-in-out infinite;\n}\n\n.discovery-screenshot-skeleton-block {\n  position: absolute;\n  inset: 0;\n}\n\n.discovery-screenshot-skeleton-line {\n  width: 70%;\n  height: 0.8rem;\n  border-radius: 4px;\n}\n\n.discovery-screenshot-fallback {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  font-weight: 500;\n  background: repeating-linear-gradient(45deg, #f3f4f6, #f3f4f6 10px, #eceff3 10px, #eceff3 20px);\n}\n\n.discovery-screenshot-zoom {\n  position: absolute;\n  right: 0.5rem;\n  bottom: 0.5rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.25rem 0.6rem;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.78);\n  color: var(--white);\n  font-size: 0.7rem;\n  font-weight: 600;\n  opacity: 0;\n  transform: translateY(4px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  pointer-events: none;\n}\n\n.discovery-screenshot-card:hover .discovery-screenshot-zoom,\n.discovery-screenshot-card:focus-within .discovery-screenshot-zoom {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* URL path + tooltip */\n.discovery-screenshot-path {\n  position: relative;\n  padding: 0.6rem 0.75rem;\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;\n  font-size: 0.74rem;\n  line-height: 1.4;\n  color: var(--text-secondary);\n  border-radius: 0 0 9px 9px;\n}\n\n.discovery-screenshot-path.has-tooltip {\n  cursor: help;\n}\n\n.discovery-screenshot-path:focus-visible {\n  outline: 2px solid var(--primary-color);\n  outline-offset: -2px;\n}\n\n.discovery-screenshot-path-text {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.discovery-screenshot-tooltip {\n  position: absolute;\n  left: 0.5rem;\n  right: 0.5rem;\n  bottom: calc(100% + 6px);\n  z-index: 20;\n  padding: 0.5rem 0.65rem;\n  border-radius: 6px;\n  background: #0f172a;\n  color: #f8fafc;\n  font-size: 0.72rem;\n  line-height: 1.45;\n  white-space: normal;\n  word-break: break-all;\n  box-shadow: var(--box-shadow-md);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(4px);\n  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s;\n  pointer-events: none;\n}\n\n.discovery-screenshot-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 1rem;\n  border: 6px solid transparent;\n  border-top-color: #0f172a;\n}\n\n.discovery-screenshot-path:hover .discovery-screenshot-tooltip,\n.discovery-screenshot-path:focus .discovery-screenshot-tooltip,\n.discovery-screenshot-path:focus-visible .discovery-screenshot-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n/* Empty / error states */\n.discovery-screenshot-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 2.5rem 1rem;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.discovery-screenshot-state svg {\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n}\n\n.discovery-screenshot-state.is-error svg {\n  color: var(--danger-color);\n}\n\n.discovery-screenshot-state strong {\n  font-size: 0.95rem;\n  color: var(--text-primary);\n}\n\n.discovery-screenshot-state span {\n  max-width: 420px;\n  font-size: 0.85rem;\n}\n\n.discovery-screenshot-state .wizard-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.75rem;\n}\n\n/* Infinite scroll footer */\n.discovery-screenshot-sentinel {\n  width: 100%;\n  height: 1px;\n}\n\n.discovery-screenshot-footer {\n  display: flex;\n  justify-content: center;\n  padding-top: 1.25rem;\n  min-height: 1.5rem;\n}\n\n.discovery-screenshot-footer-status {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n}\n\n.discovery-screenshot-footer-status.is-error {\n  color: var(--danger-color);\n}\n\n.discovery-screenshot-link-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--primary-color);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.discovery-screenshot-link-btn:hover {\n  text-decoration: underline;\n}\n\n/* Full-screen preview */\n.discovery-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 999999;\n  display: flex;\n  flex-direction: column;\n  background: rgba(2, 6, 23, 0.92);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  animation: discovery-fade-in 0.18s ease;\n}\n\n.discovery-lightbox-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-shrink: 0;\n  padding: 0.85rem 1.25rem;\n  color: #e2e8f0;\n}\n\n.discovery-lightbox-title {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  min-width: 0;\n}\n\n.discovery-lightbox-path {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;\n  font-size: 0.875rem;\n}\n\n.discovery-lightbox-counter {\n  flex-shrink: 0;\n  padding: 0.15rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.discovery-lightbox-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.discovery-lightbox-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  height: 38px;\n  min-width: 38px;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.discovery-lightbox-icon-btn.is-labelled {\n  padding: 0 0.9rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.discovery-lightbox-icon-btn:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.discovery-lightbox-icon-btn:focus-visible {\n  outline: 2px solid var(--white);\n  outline-offset: 2px;\n}\n\n.discovery-lightbox-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0 1rem 1rem;\n}\n\n.discovery-lightbox-nav {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--white);\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.discovery-lightbox-nav:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.discovery-lightbox-nav:focus-visible {\n  outline: 2px solid var(--white);\n  outline-offset: 2px;\n}\n\n.discovery-lightbox-nav:disabled {\n  opacity: 0.25;\n  cursor: default;\n}\n\n.discovery-lightbox-figure {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  margin: 0;\n  display: flex;\n  overflow: auto;\n}\n\n.discovery-lightbox-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white);\n}\n\n/* `margin: auto` centers the image but never pushes its top out of reach when it is taller than the viewport */\n.discovery-lightbox-img {\n  display: block;\n  margin: auto;\n  max-width: 100%;\n  height: auto;\n  border-radius: 6px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.discovery-lightbox-figure.is-fit .discovery-lightbox-img {\n  max-height: 100%;\n  object-fit: contain;\n  cursor: zoom-in;\n}\n\n.discovery-lightbox-figure.is-width .discovery-lightbox-img {\n  cursor: zoom-out;\n}\n\n.discovery-lightbox-img.is-loaded {\n  opacity: 1;\n}\n\n.discovery-lightbox-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  max-width: 420px;\n  margin: auto;\n  color: #cbd5e1;\n  text-align: center;\n}\n\n.discovery-lightbox-error strong {\n  color: var(--white);\n  font-size: 1rem;\n}\n\n.discovery-lightbox-error span {\n  font-size: 0.85rem;\n}\n\n.discovery-lightbox-hint {\n  flex-shrink: 0;\n  padding: 0 1rem 0.75rem;\n  text-align: center;\n  font-size: 0.72rem;\n  color: rgba(226, 232, 240, 0.6);\n}\n\n@media (max-width: 768px) {\n  .discovery-lightbox-topbar {\n    padding: 0.65rem 0.75rem;\n  }\n\n  .discovery-lightbox-icon-btn.is-labelled span {\n    display: none;\n  }\n\n  .discovery-lightbox-icon-btn.is-labelled {\n    padding: 0;\n  }\n\n  .discovery-lightbox-body {\n    gap: 0.4rem;\n    padding: 0 0.5rem 0.75rem;\n  }\n\n  .discovery-lightbox-nav {\n    width: 38px;\n    height: 38px;\n  }\n\n  .discovery-lightbox-hint {\n    display: none;\n  }\n}\n\n@keyframes discovery-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n@keyframes discovery-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .discovery-screenshot-card,\n  .discovery-screenshot-img,\n  .discovery-screenshot-zoom,\n  .discovery-screenshot-tooltip,\n  .discovery-lightbox,\n  .discovery-lightbox-img {\n    animation: none;\n    transition: none;\n  }\n\n  .discovery-screenshot-card:hover,\n  .discovery-screenshot-card:focus-within {\n    transform: none;\n  }\n\n  .discovery-screenshot-card:hover .discovery-screenshot-img.is-loaded {\n    transform: none;\n  }\n\n  .discovery-screenshot-skeleton-block,\n  .discovery-screenshot-skeleton-line {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
